<!--
 * @Author: Scarlett Xiao
 * @Date: 2022-01-04 15:05:32
 * @LastEditors: zcy
 * @LastEditTime: 2022-09-01 11:20:41
-->
<template>
  <!-- 养成 -->
  <div class="content-wrap">
    <!-- 内容盒子 -->
    <OverviewTab>
      <div class="content-box">
        <!-- 左边 -->
        <div>
          <div class="sub-box">
            <span class="big-title">
              <span @click="isShowChartClick('annalsTargetInfo', 'chart')"
                >年度经营目标完成情况</span
              >
              <RouteTarget
                class="title-right"
                :pathName="'month-yc-annals-target'"
              >
                <span
                  >查看更多<i
                    class="iconfont icon-a-PresidentDesktop-Viewmore"
                  ></i
                ></span>
              </RouteTarget>
            </span>
            <!-- 图表 -->
            <div class="chart-content">
              <div class="sub-titles">
                <span
                  @click="annalsTargetInfo('3')"
                  :class="annalsTarget.searchType == '3' ? 'sub-active' : ''"
                >
                  销售产值
                </span>
                <span
                  @click="annalsTargetInfo('2')"
                  :class="annalsTarget.searchType == '2' ? 'sub-active' : ''"
                >
                  收获产量
                </span>
                <span
                  @click="annalsTargetInfo('1')"
                  :class="annalsTarget.searchType == '1' ? 'sub-active' : ''"
                >
                  投苗完成情况
                </span>
                <span
                  @click="annalsTargetInfo('4')"
                  :class="annalsTarget.searchType == '4' ? 'sub-active' : ''"
                >
                  养殖利润
                </span>
              </div>
              <div
                class="chart-empty"
                id="chart-annals-target"
                style="height: 100%; width: 100%"
              ></div>
              <MySlider
                :total="annalsTarget.xAxis.data.length"
                @change="getStartValue($event, annalsTarget)"
              ></MySlider>
            </div>
          </div>
          <div class="sub-box">
            <span class="big-title">
              <span @click="isShowChartClick('putInfo', 'chart')"
                >投放概览</span
              >
              <RouteTarget class="title-right" :pathName="'month-yc-put'">
                <span
                  >查看更多<i
                    class="iconfont icon-a-PresidentDesktop-Viewmore"
                  ></i
                ></span>
              </RouteTarget>
            </span>
            <!-- 图表 -->
            <div class="chart-content">
              <div class="sub-titles">
                <span
                  @click="putInfo('1')"
                  :class="put.searchType == '1' ? 'sub-active' : ''"
                >
                  投苗情况
                </span>
                <span
                  @click="putInfo('2')"
                  :class="put.searchType == '2' ? 'sub-active' : ''"
                >
                  排塘情况
                </span>
              </div>
              <div
                class="chart-empty"
                id="chart-put"
                style="height: 100%; width: 100%"
              ></div>
              <MySlider
                :total="put.xAxis.data.length"
                @change="getStartValue($event, put)"
              ></MySlider>
            </div>
          </div>
          <div class="sub-box">
            <span class="big-title">
              <span @click="isShowChartClick('storageInfo', 'chart')"
                >存塘概览</span
              >
              <RouteTarget class="title-right" :pathName="'month-yc-overage'">
                <span
                  >查看更多<i
                    class="iconfont icon-a-PresidentDesktop-Viewmore"
                  ></i
                ></span>
              </RouteTarget>
            </span>
            <!-- 图表 -->
            <div class="chart-content">
              <div class="sub-titles">
                <span
                  @click="storageInfo('1')"
                  :class="storage.searchType == '1' ? 'sub-active' : ''"
                >
                  实时存塘量
                </span>
                <span
                  @click="storageInfo('2')"
                  :class="storage.searchType == '2' ? 'sub-active' : ''"
                >
                  月存塘成本
                </span>
              </div>
              <div
                class="chart-empty"
                id="chart-storage"
                style="height: 100%; width: 100%"
              ></div>
              <MySlider
                :total="storage.xAxis.data.length + 3"
                @change="getStartValue($event, storage)"
              ></MySlider>
            </div>
          </div>
        </div>
        <!-- 中间 -->
        <div>
          <div class="num-box">
            <span>
              <CountIn
                :startVal="0"
                :endVal="totalData.saleAmount"
                :speed="800"
                :decimals="0"
                :isReverse="false"
              />
              <span class="count-txt">销售产值/万元</span>
            </span>
            <span>
              <CountIn
                :startVal="0"
                :endVal="totalData.harvestYield"
                :speed="800"
                :decimals="0"
                :isReverse="false"
              />
              <span class="count-txt">收获产量/万斤</span>
            </span>
            <span>
              <CountIn
                :startVal="0"
                :endVal="totalData.costTotal"
                :speed="800"
                :decimals="0"
                :isReverse="false"
              />
              <span class="count-txt">存塘成本/万元</span>
            </span>
            <span>
              <CountIn
                :startVal="0"
                :endVal="totalData.saleProfit"
                :speed="800"
                :decimals="0"
                :isReverse="false"
              />
              <span class="count-txt">养成利润/万元</span>
            </span>
          </div>
          <div class="sub-box sub-box-middle">
            <span class="big-title">
              <span @click="isShowChartClick('salesInfo', 'chart')"
                >销售概览</span
              >
              <RouteTarget class="title-right" :pathName="'month-yc-sales'">
                <span
                  >查看更多<i
                    class="iconfont icon-a-PresidentDesktop-Viewmore"
                  ></i
                ></span>
              </RouteTarget>
            </span>
            <!-- 图表 -->
            <div class="chart-content">
              <div class="sub-titles">
                <span
                  @click="salesInfo('0')"
                  :class="sales.searchType == '0' ? 'sub-active' : ''"
                >
                  产值
                </span>
                <span
                  @click="salesInfo('1')"
                  :class="sales.searchType == '1' ? 'sub-active' : ''"
                >
                  销售量
                </span>
                <span
                  @click="salesInfo('2')"
                  :class="sales.searchType == '2' ? 'sub-active' : ''"
                >
                  客户应收
                </span>
              </div>
              <div
                class="chart-empty"
                id="chart-sales"
                style="height: 100%; width: 100%"
              ></div>
              <MySlider
                :total="sales.xAxis.data.length + 3"
                @change="getStartValue($event, sales)"
              ></MySlider>
            </div>
          </div>
          <div class="sub-box sub-box-middle">
            <span class="big-title">
              <span @click="isShowChartClick('prefixInfo', 'chart')"
                >单位利润计划与实际比</span
              >
              <RouteTarget class="title-right" :pathName="'month-yc-profit'">
                <span
                  >查看更多<i
                    class="iconfont icon-a-PresidentDesktop-Viewmore"
                  ></i
                ></span>
              </RouteTarget>
            </span>
            <!-- 图表 -->
            <div class="chart-content">
              <div class="sub-titles">
                <span
                  @click="prefixInfo('0')"
                  :class="prefix.searchType == '0' ? 'sub-active' : ''"
                >
                  成本
                </span>
                <span
                  @click="prefixInfo('1')"
                  :class="prefix.searchType == '1' ? 'sub-active' : ''"
                >
                  售价
                </span>
                <span
                  @click="prefixInfo('2')"
                  :class="prefix.searchType == '2' ? 'sub-active' : ''"
                >
                  利润
                </span>
              </div>
              <div
                class="chart-empty"
                id="chart-prefix"
                style="height: 100%; width: 100%"
              ></div>
              <MySlider
                :total="prefix.xAxis.data.length"
                @change="getStartValue($event, prefix)"
              ></MySlider>
            </div>
          </div>
        </div>
        <!-- 右边 -->
        <div>
          <div class="sub-box">
            <span class="big-title">
              <span @click="isShowChartClick('costInfo', 'chart')"
                >成本概览</span
              >
              <RouteTarget class="title-right" :pathName="'month-yc-cost'">
                <span
                  >查看更多<i
                    class="iconfont icon-a-PresidentDesktop-Viewmore"
                  ></i
                ></span>
              </RouteTarget>
            </span>
            <!-- 图表 -->
            <div class="chart-content">
              <div id="chart-cost" style="height: 100%; width: 100%"></div>
              <MySlider
                :total="cost.xAxis.data.length"
                @change="getStartValue($event, cost)"
              ></MySlider>
            </div>
          </div>
          <div class="sub-box">
            <span class="big-title">
              <span @click="isShowChartClick('harvestInfo', 'chart')"
                >收获概览</span
              >
              <RouteTarget class="title-right" :pathName="'month-yc-harvest'">
                <span
                  >查看更多<i
                    class="iconfont icon-a-PresidentDesktop-Viewmore"
                  ></i
                ></span>
              </RouteTarget>
            </span>
            <!-- 图表 -->
            <div class="chart-content">
              <div class="sub-titles">
                <span
                  @click="harvestInfo('0')"
                  :class="harvest.searchType == '0' ? 'sub-active' : ''"
                >
                  产量
                </span>
                <span
                  @click="harvestInfo('1')"
                  :class="harvest.searchType == '1' ? 'sub-active' : ''"
                >
                  塘口收获情况
                </span>
              </div>
              <div
                class="chart-empty"
                id="chart-harvest"
                style="height: 100%; width: 100%"
              ></div>
              <MySlider
                :total="harvest.xAxis.data.length + 3"
                @change="getStartValue($event, harvest)"
              ></MySlider>
            </div>
          </div>
          <div class="sub-box">
            <span class="big-title">
              <span @click="isShowChartClick('quotaInfo', 'chart')"
                >指标概览</span
              >
              <RouteTarget class="title-right" :pathName="'month-yc-quota'">
                <span
                  >查看更多<i
                    class="iconfont icon-a-PresidentDesktop-Viewmore"
                  ></i
                ></span>
              </RouteTarget>
            </span>
            <!-- 图表 -->
            <div class="chart-content">
              <div class="sub-titles">
                <span
                  @click="quotaInfo('0')"
                  :class="quota.searchType == '0' ? 'sub-active' : ''"
                >
                  成活率
                </span>
                <span
                  @click="quotaInfo('1')"
                  :class="quota.searchType == '1' ? 'sub-active' : ''"
                >
                  饲料系数
                </span>
                <span
                  @click="quotaInfo('3')"
                  :class="quota.searchType == '3' ? 'sub-active' : ''"
                >
                  动保金额(斤养殖)
                </span>
              </div>
              <div
                class="chart-empty"
                id="chart-quota"
                style="height: 100%; width: 100%"
              ></div>
              <MySlider
                :total="quota.xAxis.data.length"
                @change="getStartValue($event, quota)"
              ></MySlider>
            </div>
          </div>
        </div>
      </div>
      <el-dialog
        width="80%"
        @close="isShowChartClose"
        class="show-chart-box"
        :visible.sync="isShowChart"
      >
        <span class="show-chart-title">{{ showChart.title }}</span>
        <div class="type_btn_container">
          <span
            @click="isShowChartTypeClick(showChart.chartType, item.id)"
            v-bind:class="{
              'sub-active': showChart.searchType == item.id,
            }"
            :key="index"
            v-for="(item, index) in showChart.targetCategory"
          >
            {{ item.name }}
          </span>
        </div>
        <div class="cancel-delete" @click="isShowChart = false"></div>
        <div class="chart-content" id="chart_vm"></div>
        <MySlider
          style="width: 85% !important; bottom: 80px !important"
          v-if="isDataZoomShow"
          :total="quota.xAxis.data.length"
          @change="getStartValue($event, showChart)"
        ></MySlider>
      </el-dialog>
    </OverviewTab>
  </div>
</template>

<script>
import * as $echarts from "echarts";
import OverviewTab from "@/components/pc/overview-tab.vue";
import RouteTarget from "@/components/pc/route-target.vue";
import CountIn from "@/components/pc/count-in.vue";
import service from "../../../../api/middle/month/overview";
import debounce from "@/utils/debounce";
import MySlider from "@/components/pc/my-slider.vue";
export default {
  name: "yc",
  components: {
    OverviewTab,
    RouteTarget,
    CountIn,
    MySlider,
  },
  props: {
    date: "",
    dateType: "",
  },
  inject: ["app"],
  data() {
    return {
      // 自定义放大图表dataZoom是否显示
      isDataZoomShow: false,
      // 放大查看图表参数对象
      showChart: {
        chartType: "",
        title: "",
        idName: "chart_vm",
        searchType: "",
        chartDom: null,
        unit: "",
        legend: [],
        series: [],
        xAxis: [],
        colors: [],
        targetCategory: [],
        option: {},
      },
      isShowChart: false, //放大查看图表（报表）数据
      orgId: "", // 一级机构
      type: "", // 时间类型(Y: 年, M: 年月)
      year: "", // 年份(yyyy)
      month: "", // 年月(yyyy-MM)
      breedTypeClass: "fish", // 阶段类型（egg：育苗，fish：养成）
      // 汇总数据
      totalData: {
        saleAmount: 0, // 销售产值
        saleProfit: 0, // 育苗利润【养成利润】
        harvestYield: 0, // 	收获产量
        costTotal: 0, // 	存塘成本
      },
      lineColors: [],
      barColors: [],
      // 年度经营目标完成情况
      annalsTarget: {
        searchType: "3", // 查询指标类型 1：完成情况、2：产量、3：产值、4：利润
        idName: "chart-annals-target",
        chartDom: null,
        legend: {
          data: [],
        },
        unit: { 3: "万元", 2: "万斤", 1: "万尾", 4: "万元" },
        series: {
          data1: {
            name: "",
            data: [],
          },
          data2: {
            name: "",
            data: [],
          },
          data3: {
            name: "",
            data: [],
          },
        },
        xAxis: {
          data: [],
        },
        option: {},
      },
      // 投放概览
      put: {
        searchType: "1", // 查询指标类型 1：投卵、苗、2：排塘
        idName: "chart-put",
        chartDom: null,
        legend: {
          data: [],
        },
        unit: { 1: "万尾", 2: "万元" },
        series: {
          data1: {
            name: "",
            data: [],
          },
        },
        xAxis: {
          data: [],
        },
        option: {},
      },
      // 存塘概览
      storage: {
        searchType: "1", // 查询指标类型 1：实时存塘量（养成、育苗）图表、2：存塘成本（养成、育苗）图表
        idName: "chart-storage",
        chartDom: null,
        legend: {
          data: [],
        },
        unit: { 1: ["尾", "口"], 2: "万元" },
        series: {
          data1: {
            name: "",
            data: [],
          },
        },
        xAxis: {
          data: [],
        },
        option: {},
      },
      // 销售概览
      sales: {
        searchType: "0", // 查询类型 0：产值、1：销售量、2：客户应收
        idName: "chart-sales",
        chartDom: null,
        legend: {
          data: [],
        },
        unit: { 0: "万元", 1: ["尾", "元/尾"], 2: "万元" },
        series: {
          data1: {
            name: "",
            data: [],
          },
        },
        xAxis: {
          data: [],
        },
        option: {},
      },
      // 单位利润计划与实际比
      prefix: {
        searchType: "0", // 查询类型 0：成本、1：售价、2：利润
        idName: "chart-prefix",
        chartDom: null,
        legend: {
          data: [],
        },
        series: {
          data1: {
            name: "",
            data: [],
          },
        },
        xAxis: {
          data: [],
        },
        option: {},
      },
      // 成本概览
      cost: {
        idName: "chart-cost",
        chartDom: null,
        legend: {
          data: [],
        },
        series: {
          data1: {
            name: "",
            data: [],
          },
        },
        xAxis: {
          data: [],
        },
        option: {},
      },
      // 收获概览
      harvest: {
        searchType: "0", // 查询类型 0：产量、1：塘口
        idName: "chart-harvest",
        chartDom: null,
        legend: {
          data: [],
        },
        unit: { 0: ["万斤", "斤/亩"], 1: "口" },
        series: {
          data1: {
            name: "",
            data: [],
          },
        },
        xAxis: {
          data: [],
        },
        option: {},
      },
      // 指标概览
      quota: {
        searchType: "0", // 查询类型 0:成活率、1：饲料系数、2：每公斤卵出苗量、3：动保金额
        idName: "chart-quota",
        chartDom: null,
        legend: {
          data: [],
        },
        series: {
          data1: {
            name: "",
            data: [],
            stack: "",
          },
        },
        xAxis: {
          data: [],
        },
        option: {},
      },
    };
  },
  methods: {
    // 关闭自定义formaater
    closeFormatter(option) {
      option.baseOption &&
        option.baseOption.tooltip &&
        option.baseOption.tooltip.trigger &&
        delete option.baseOption.tooltip.trigger;
      option.baseOption &&
        option.baseOption.tooltip &&
        option.baseOption.tooltip.formatter &&
        delete option.baseOption.tooltip.formatter;
      option.tooltip &&
        option.tooltip.formatter &&
        delete option.tooltip.formatter;
      option.tooltip && option.tooltip.trigger && delete option.tooltip.trigger;
    },
    // 大屏显示图表关闭事件
    isShowChartClose() {
      this.showChart = {
        idName: "chart_vm",
        searchType: "",
        chartDom: null,
        unit: "",
        legend: [],
        series: [],
        xAxis: [],
        colors: [],
        option: {},
      };
      this.isDataZoomShow = false;
    },
    // 大屏内type切换点击事件
    isShowChartTypeClick(type, searchType) {
      this.showChart.searchType = searchType;
      if (type === "annalsTargetInfo") {
        this.annalsTargetInfo(searchType, true);
        // console.log("切换年度经营目标完成情况图表大屏");
      } else if (type === "putInfo") {
        this.putInfo(searchType, true);
        // console.log("切换投放概览图表大屏");
      } else if (type === "storageInfo") {
        this.storageInfo(searchType, true);
        // console.log("切换存塘概览图表大屏");
      } else if (type === "salesInfo") {
        this.salesInfo(searchType, true);
      } else if (type === "prefixInfo") {
        this.prefixInfo(searchType, true);
        // console.log("切换单位利润计划与实际比图表大屏");
      } else if (type === "cost") {
        // console.log("切换成本概览图表大屏");
      } else if (type === "harvestInfo") {
        this.harvestInfo(searchType, true);
        // console.log("切换收获概览图表大屏");
      } else if (type === "quotaInfo") {
        this.quotaInfo(searchType, true);
      }
    },
    // 大屏显示图表点击事件
    isShowChartClick(type, showType) {
      this.showChart.chartType = type;
      if (type === "annalsTargetInfo") {
        this.showChart.title = "年度经营目标完成情况";
        this.showChart.targetCategory = [
          { id: "3", name: "销售产值" },
          { id: "2", name: "收获产量" },
          { id: "1", name: "投卵完成情况" },
          { id: "4", name: "养殖利润" },
        ];
        this.showChart.searchType = this.annalsTarget.searchType;
        this.showChart.unit = this.annalsTarget.unit;
        this.annalsTargetInfo(this.showChart.searchType, true);
      } else if (type === "putInfo") {
        this.showChart.title = "投放概览";
        this.showChart.targetCategory = [
          { id: "1", name: "投卵情况" },
          { id: "2", name: "排塘情况" },
        ];
        this.showChart.searchType = this.put.searchType;
        this.putInfo(this.showChart.searchType, true);
        console.log("显示投放概览图表大屏");
      } else if (type === "storageInfo") {
        this.showChart.title = "存塘概览";
        this.showChart.targetCategory = [
          { id: "1", name: "实时存塘量" },
          { id: "2", name: "月存塘成本" },
        ];
        this.showChart.searchType = this.storage.searchType;
        this.storageInfo(this.showChart.searchType, true);
        console.log("显示存塘概览图表大屏");
      } else if (type === "salesInfo") {
        this.showChart.title = "销售概览";
        this.showChart.targetCategory = [
          { id: "0", name: "产值" },
          { id: "1", name: "销售量" },
          { id: "2", name: "客户应收" },
        ];
        this.showChart.searchType = this.sales.searchType;
        this.salesInfo(this.showChart.searchType, true);
        console.log("显示销售概览图表大屏");
      } else if (type === "prefixInfo") {
        this.showChart.title = "单位利润计划与实际比";
        this.showChart.targetCategory = [
          { id: "0", name: "成本" },
          { id: "1", name: "售价" },
          { id: "2", name: "利润" },
        ];
        this.showChart.searchType = this.prefix.searchType;
        this.prefixInfo(this.showChart.searchType, true);
      } else if (type === "costInfo") {
        this.showChart.title = "成本概览";
        this.showChart.searchType = this.cost.searchType;
        this.costInfo(true);
        console.log("显示成本概览图表大屏");
      } else if (type === "harvestInfo") {
        this.showChart.title = "收获概览";
        this.showChart.targetCategory = [
          { id: "0", name: "产量" },
          { id: "1", name: "塘口收获情况" },
        ];
        this.showChart.searchType = this.harvest.searchType;
        this.harvestInfo(this.showChart.searchType, true);
      } else if (type === "quotaInfo") {
        this.showChart.title = "指标概览";
        this.showChart.targetCategory = [
          { id: "0", name: "成活率" },
          { id: "1", name: "饲料系数" },
          { id: "3", name: "动保金额（斤养殖）" },
        ];
        this.showChart.searchType = this.quota.searchType;
        this.quotaInfo(this.showChart.searchType, true);
      }
    },
    /**
     * @Author: lishiqiao
     * @Date: 2022-02-16 17:41:05
     * @description: 处理图表数据
     * @param {*} data 接口数据
     * @param {*} obj 存储图表数据的对象
     */
    handleChartData(data, obj) {
      const DATA = data;
      // legend
      obj.legend.data =
        DATA.map((re) => {
          return re.legendName;
        }) || [];
      // xAxis
      (DATA.length > 0 &&
        (obj.xAxis.data = DATA[0].dataList.map((re) => {
          return re.xAxisName;
        }))) ||
        [];
      // series
      (DATA.length > 0 &&
        DATA.forEach((re) => {
          obj.legend.data.forEach((re1, idx) => {
            if (re.legendName == re1) {
              obj.series[`data${idx + 1}`] = {
                name: re.legendName,
                data: re.dataList.map((re2) => {
                  return re2.yAxisValue;
                }),
              };
            }
          });
        })) ||
        [];
    },
    /**
     * @Author: lishiqiao
     * @Date: 2022-02-17 09:47:55
     * @description: 重置图表数据
     * @param {*} obj 存储图表数据的对象
     */
    resetChartData(obj) {
      obj.legend.data = [];
      for (const key in obj.series) {
        const item = obj.series[key];
        item.name = "";
        item.data = [];
      }
      obj.xAxis.data = [];
    },
    /**
     * @Author: lishiqiao
     * @Date: 2022-02-28 14:12:01
     * @description: 生成指定个数随机颜色
     * @param {*} num
     */
    randomColors(num) {
      this.lineColors = ["#6473F5", "#811DFF", "#E441BE"];
      this.barColors = [
        ["#907BFE", "#5442FF"],
        ["#B681FF", "#8540FF"],
        ["#80B69F", "#68A380"],
      ];
      let count;
      num <= 3 ? (count = 0) : (count = num - 3);
      for (let i = 0; i < count; i++) {
        let barColors = this.$color.getItemColors(this.$color.randex(), 4);
        this.lineColors.push(this.$color.randex());
        this.barColors.push([barColors[barColors.length - 1], barColors[0]]);
      }
    },
    /**
     * @Author: lishiqiao
     * @Date: 2022-03-17 17:22:40
     * @description: 获取图表startValue
     * @param {*} event
     * @param {*} obj
     */
    getStartValue(event, obj) {
      let option = JSON.parse(JSON.stringify(obj.option));
      if (!option.baseOption) {
        option.animationDurationUpdate = 60;
        option.dataZoom[0].startValue = event;
      } else {
        option.baseOption.animationDurationUpdate = 60;
        option.baseOption.dataZoom[0].startValue = event;
        option.baseOption.dataZoom[1].startValue = event;
        option.baseOption.dataZoom[2].startValue = event;
      }
      obj.chartDom.setOption(option);
    },
    // 年度经营目标完成情况option
    annalsTargetChart(showBol) {
      // 指定图表的配置项和数据
      let option = {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross",
            crossStyle: {
              color: "#999",
            },
          },
          textStyle: {
            color: "#111E39",
            fontSize: 12,
            fontFamily: "Microsoft YaHei",
            fontWeight: 400,
          },
          formatter: (params) => {
            let dataStr = `<div><p style="font-weight:bold;margin:0 8px 10px;">${params[0].name}</p></div>`;
            params.forEach((item, i) => {
              if (item.seriesName != "完成率") {
                dataStr += `<div style=${
                  !item.data ? "display:none;" : "display:block"
                }>
          <div style="margin: 0 8px;">
            <span style="display:inline-block;margin-right:4px;width:8px;height:8px;border-radius:2px;background:linear-gradient(0deg, ${
              typeof item.color == "object"
                ? item.color.colorStops[0].color
                : ""
            } 0%, ${
                  typeof item.color == "object"
                    ? item.color.colorStops[1].color
                    : ""
                } 100%);"></span>
            <span>${item.seriesName}</span>
            <span style="float:right;color:#000000;margin-left:20px;">${
              item.data +
              " " +
              this.annalsTarget.unit[this.annalsTarget.searchType]
            }</span>
          </div>
        </div>`;
              } else {
                dataStr += `<div style=${
                  !item.data ? "display:none;" : "display:block"
                }>
          <div style="margin: 0 6px;">
            <span style="display:inline-block;position:relative;width:8px;margin-right:5px;
            ">
            <svg class="icon" style="position:absolute;top:-9px" viewBox="0 0 1024 1024" xmlns="http://www.w3.org/2000/svg" width="12" height="12"><path d="M682.667 307.2c17.066 0 34.133 17.067 34.133 34.133v341.334c0 17.066-17.067 34.133-34.133 34.133H341.333c-17.066 0-34.133-17.067-34.133-34.133V341.333c0-17.066 17.067-34.133 34.133-34.133h341.334m0-136.533H341.333c-93.866 0-170.666 76.8-170.666 170.666v341.334c0 93.866 76.8 170.666 170.666 170.666h341.334c93.866 0 170.666-76.8 170.666-170.666V341.333c0-93.866-76.8-170.666-170.666-170.666z" fill="#1afa29"/></svg>
            </span>
            <span>${item.seriesName}</span>
            <span style="float:right;color:#000000;margin-left:20px;">${
              item.data
            } %</span>
          </div>
        </div>`;
              }
            });
            return dataStr;
          },
        },
        legend: {
          type: "scroll",
          bottom: 10,
          left: 30,
          itemHeight: 8,
          itemGap: 40,
          itemWidth: 8,
          textStyle: {
            fontSize: 12,
            fontFamily: "SimSun",
            fontWeight: 400,
            color: "#9BA7BF",
          },
          pageTextStyle: {
            color: "#9BA7BF",
            fontSize: 12,
            fontFamily: "SimSun",
          },
          pageIconColor: "#AAAAAA", //翻页下一页的三角按钮颜色
          pageIconInactiveColor: "#333333", //翻页按钮不激活时（即翻页到头时）的颜色。
          pageIconSize: 11, //翻页按钮大小
          data: [
            {
              name: this.annalsTarget.legend.data[0],
              icon: "path://M682.666667 725.333333H341.333333c-93.866667 0-170.666667-76.8-170.666666-170.666666v-341.333334c0-93.866667 76.8-170.666667 170.666666-170.666666h341.333334c93.866667 0 170.666667 76.8 170.666666 170.666666V554.666667c0 93.866667-76.8 170.666667-170.666666 170.666666z",
            },
            {
              name: this.annalsTarget.legend.data[1],
              icon: "path://M682.666667 725.333333H341.333333c-93.866667 0-170.666667-76.8-170.666666-170.666666v-341.333334c0-93.866667 76.8-170.666667 170.666666-170.666666h341.333334c93.866667 0 170.666667 76.8 170.666666 170.666666V554.666667c0 93.866667-76.8 170.666667-170.666666 170.666666z",
            },
            {
              name: this.annalsTarget.legend.data[2],
              icon: "path://M682.666667 588.8c17.066667 0 34.133333-17.066667 34.133333-34.133333v-341.333334c0-17.066667-17.066667-34.133333-34.133333-34.133333H341.333333c-17.066667 0-34.133333 17.066667-34.133333 34.133333V554.666667c0 17.066667 17.066667 34.133333 34.133333 34.133333h341.333334M682.666667 725.333333H341.333333c-93.866667 0-170.666667-76.8-170.666666-170.666666v-341.333334c0-93.866667 76.8-170.666667 170.666666-170.666666h341.333334c93.866667 0 170.666667 76.8 170.666666 170.666666V554.666667c0 93.866667-76.8 170.666667-170.666666 170.666666z",
            },
          ],
        },
        grid: {
          right: 30,
          top: 75,
          bottom: showBol ? 100 : 49,
          left: 30,
          width: "auto",
          containLabel: true,
        },
        dataZoom: [
          {
            dataBackground: {
              //未选中部分数据阴影样式
              lineStyle: {
                opacity: 0,
              },
              areaStyle: {
                opacity: 0,
              },
            },
            selectedDataBackground: {
              //选中部分数据阴影样式
              lineStyle: {
                opacity: 0,
              },
              areaStyle: {
                opacity: 0,
              },
            },
            type: "slider",
            show: showBol ? true : false,
            right: 42,
            bottom: showBol ? 60 : 35,
            height: 6,
            borderColor: "#383848", //缩放条边框颜色
            fillerColor: "#383848", //选中的阴影填充背景颜色
            backgroundColor: "rgb(30,30,43)", // 背景颜色
            maxValueSpan: 6,
            handleSize: 0,
            brushSelect: false,
            showDetail: false,
            moveHandleStyle: {},
          },
        ],
        xAxis: {
          type: "category",
          axisTick: {
            show: false,
          },
          axisLine: {
            show: true,
            lineStyle: {
              color: "#46494A",
            },
          },
          axisPointer: {
            type: "shadow",
          },
          axisLabel: {
            interval: 0,
            margin: 10,
            textStyle: {
              fontSize: 12,
              fontFamily: "SimSun",
              fontWeight: 400,
              color: "#838DA1",
            },
          },
          data: this.annalsTarget.xAxis.data,
        },
        yAxis: [
          {
            type: "value",
            min: 0,
            axisLabel: {
              margin: 15,
              textStyle: {
                fontSize: 12,
                fontFamily: "SimSun",
                fontWeight: 400,
                color: "#838DA1",
              },
              formatter: "{value}",
            },
            splitLine: {
              show: true,
              // interval: 0,
              lineStyle: {
                color: "#46494A",
                type: [10, 10],
                dashOffset: 5,
              },
            },
          },
          {
            type: "value",
            interval: 10,
            axisLabel: {
              margin: 10,
              textStyle: {
                fontSize: 12,
                fontFamily: "SimSun",
                fontWeight: 400,
                color: "#838DA1",
              },
              formatter: "",
            },
            splitLine: {
              show: false,
            },
          },
        ],
        series: [
          {
            name: this.annalsTarget.legend.data[0],
            type: "bar",
            tooltip: {
              valueFormatter: function (value) {
                return value;
              },
            },
            barMaxWidth: showBol ? "16" : "4",
            barGap: showBol ? 0 : 3,
            label: {
              normal: {
                show: true,
                fontSize: 12,
                color: "#ffffff",
                position: "top",
                formatter: (params) => {
                  if (params.value == 0) {
                    return ``;
                  }
                  return params.value; //随便写的值
                },
              },
            },
            itemStyle: {
              color: new $echarts.graphic.LinearGradient(0, 0, 0, 1, [
                { offset: 1, color: "#5442FF" },
                { offset: 0, color: "#907BFE" },
              ]),
              barBorderRadius: 50,
            },
            emphasis: {
              itemStyle: {
                color: new $echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  { offset: 1, color: "#5442FF" },
                  { offset: 0, color: "#907BFE" },
                ]),
              },
            },
            data: this.annalsTarget.series.data1.data,
          },
          {
            name: this.annalsTarget.legend.data[1],
            type: "bar",
            tooltip: {
              valueFormatter: function (value) {
                return value;
              },
            },
            barMaxWidth: showBol ? "16" : "4",
            barGap: showBol ? 0 : 3,
            label: {
              normal: {
                show: showBol ? true : false,
                fontSize: 12,
                color: "#ffffff",
                position: "top",
                formatter: (params) => {
                  if (params.value == 0) {
                    return ``;
                  }
                  return params.value; //随便写的值
                },
              },
            },
            itemStyle: {
              color: new $echarts.graphic.LinearGradient(0, 0, 0, 1, [
                { offset: 1, color: "#8540FF" },
                { offset: 0, color: "#B681FF" },
              ]),
              barBorderRadius: 50,
            },
            emphasis: {
              itemStyle: {
                color: new $echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  { offset: 1, color: "#8540FF" },
                  { offset: 0, color: "#B681FF" },
                ]),
              },
            },
            data: this.annalsTarget.series.data2.data,
          },
          {
            name: this.annalsTarget.legend.data[2],
            type: "line",
            color: "#51FF98",
            yAxisIndex: 1,
            lineStyle: {
              width: 1.2,
            },
            label: {
              show: showBol ? true : false,
              fontSize: 12,
              color: "#51FF98",
              position: "top",
              distance: "30",
              formatter: (params) => {
                return params.value + "%"; //随便写的值
              },
            },
            tooltip: {
              valueFormatter: function (value) {
                return value + " %";
              },
            },
            symbol: "none", //去掉折线图中的节点
            smooth: true, //true 为平滑曲线，false为直线
            data: this.annalsTarget.series.data3.data,
          },
        ],
      };
      if (option && typeof option === "object") {
        if (showBol) {
          this.isShowChart = true;
          this.closeFormatter(option);
          setTimeout(() => {
            // 基于准备好的dom，初始化echarts实例
            this.showChart.chartDom = $echarts.init(
              document.getElementById(this.showChart.idName)
            );
            // this.annalsTarget.chartDom.setOption(option, this.animationDuration);
            this.showChart.chartDom.clear();
            this.showChart.chartDom.setOption(option);
          });
          return;
          return;
        }
        // 基于准备好的dom，初始化echarts实例
        this.annalsTarget.chartDom = $echarts.init(
          document.getElementById(this.annalsTarget.idName)
        );
        this.annalsTarget.option = option;
        this.annalsTarget.chartDom.clear();
        this.annalsTarget.chartDom.setOption(option);
      }
    },
    // 投放概览option
    putChart(showBol) {
      // 指定图表的配置项和数据
      let option = {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross",
            crossStyle: {
              color: "#999",
            },
          },
          textStyle: {
            color: "#111E39",
            fontSize: 12,
            fontFamily: "Microsoft YaHei",
            fontWeight: 400,
          },
          formatter: (params) => {
            let dataStr = `<div><p style="font-weight:bold;margin:0 8px 10px;">${params[0].name}</p></div>`;
            params.forEach((item, i) => {
              dataStr += `<div style=${
                !item.data ? "display:none;" : "display:block"
              }>
          <div style="margin: 0 8px;">
            <span style="display:inline-block;margin-right:4px;width:8px;height:8px;border-radius:2px;background:linear-gradient(0deg, ${
              item.color.colorStops[0].color
            } 0%, ${item.color.colorStops[1].color} 100%);"></span>
            <span>${item.seriesName}</span>
            <span style="float:right;color:#000000;margin-left:20px;">${
              item.data + " " + this.put.unit[this.put.searchType]
            }</span>
          </div>
        </div>`;
            });
            return dataStr;
          },
        },
        legend: {
          type: "scroll",
          bottom: 10,
          left: 30,
          itemHeight: 8,
          itemGap: 40,
          itemWidth: 8,
          textStyle: {
            //图例文字的样式
            fontSize: "12px",
            fontFamily: "SimSun",
            fontWeight: 400,
            color: "#9BA7BF",
          },
          pageTextStyle: {
            color: "#9BA7BF",
            fontSize: 12,
            fontFamily: "SimSun",
          },
          pageIconColor: "#AAAAAA", //翻页下一页的三角按钮颜色
          pageIconInactiveColor: "#333333", //翻页按钮不激活时（即翻页到头时）的颜色。
          pageIconSize: 11, //翻页按钮大小
          data: this.put.legend.data.map((item) => {
            return {
              name: item,
              icon: "path://M682.666667 725.333333H341.333333c-93.866667 0-170.666667-76.8-170.666666-170.666666v-341.333334c0-93.866667 76.8-170.666667 170.666666-170.666666h341.333334c93.866667 0 170.666667 76.8 170.666666 170.666666V554.666667c0 93.866667-76.8 170.666667-170.666666 170.666666z",
            };
          }),
        },
        grid: {
          right: 30,
          top: 75,
          bottom: showBol ? 100 : 49,
          left: 30,
          width: "auto",
          containLabel: true,
        },
        dataZoom: [
          {
            dataBackground: {
              //未选中部分数据阴影样式
              lineStyle: {
                opacity: 0,
              },
              areaStyle: {
                opacity: 0,
              },
            },
            selectedDataBackground: {
              //选中部分数据阴影样式
              lineStyle: {
                opacity: 0,
              },
              areaStyle: {
                opacity: 0,
              },
            },
            type: "slider",
            show: showBol ? true : false,
            right: 33,
            bottom: showBol ? 60 : 35,
            height: 6,
            borderColor: "#383848", //缩放条边框颜色
            fillerColor: "#383848", //选中的阴影填充背景颜色
            backgroundColor: "rgb(30,30,43)", // 背景颜色
            maxValueSpan: 6,
            handleSize: 0,
            brushSelect: false,
            showDetail: false,
            moveHandleStyle: {},
          },
        ],
        xAxis: [
          {
            type: "category",
            data: this.put.xAxis.data,
            axisPointer: {
              type: "shadow",
            },
            axisLabel: {
              interval: 0,
              margin: 10,
              textStyle: {
                fontSize: 12,
                fontFamily: "SimSun",
                fontWeight: 400,
                color: "#838DA1",
              },
            },
            axisTick: {
              // x轴刻度线
              show: false,
            },
            axisLine: {
              show: true,
              lineStyle: {
                color: "#46494A",
              },
            },
          },
        ],
        yAxis: [
          {
            type: "value",
            min: 0,
            axisLabel: {
              margin: 15,
              textStyle: {
                fontSize: 12,
                fontFamily: "SimSun",
                fontWeight: 400,
                color: "#838DA1",
              },
              formatter: "{value}",
            },
            splitLine: {
              show: true,
              lineStyle: {
                color: "#46494A",
                type: [10, 10],
                dashOffset: 5,
              },
            },
          },
        ],
        series: this.put.legend.data.map((item, idx) => {
          return {
            name: this.put.series[`data${idx + 1}`].name,
            type: "bar",
            tooltip: {
              valueFormatter: function (value) {
                return value;
              },
            },
            barMaxWidth: showBol ? "10" : "4",
            barGap: showBol ? 1 : 3,
            label: {
              normal: {
                show: showBol ? true : false,
                fontSize: 12,
                color: "#ffffff",
                position: "center",
                rotate: "90",
                formatter: (params) => {
                  if (params.value == 0) {
                    return ``;
                  }
                  return params.value; //随便写的值
                },
              },
            },
            itemStyle: {
              color: new $echarts.graphic.LinearGradient(0, 0, 0, 1, [
                { offset: 1, color: this.barColors[idx][1] },
                { offset: 0, color: this.barColors[idx][0] },
              ]),
              barBorderRadius: 50,
            },
            emphasis: {
              itemStyle: {
                color: new $echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  { offset: 1, color: this.barColors[idx][1] },
                  { offset: 0, color: this.barColors[idx][0] },
                ]),
              },
            },
            data: this.put.series[`data${idx + 1}`].data,
          };
        }),
      };
      let option2 = {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross",
            crossStyle: {
              color: "#999",
            },
          },
          textStyle: {
            color: "#111E39",
            fontSize: 12,
            fontFamily: "Microsoft YaHei",
            fontWeight: 400,
          },
          formatter: (params) => {
            let dataStr = `<div><p style="font-weight:bold;margin:0 8px 10px;">${params[0].name}</p></div>`;
            params.forEach((item, i) => {
              if (item.seriesName != "排塘率") {
                dataStr += `<div style=${
                  !item.data ? "display:none;" : "display:block"
                }>
               <div style="margin: 0 8px;">
                 <span style="display:inline-block;margin-right:4px;width:8px;height:8px;border-radius:2px;background:linear-gradient(0deg, ${
                   typeof item.color == "object"
                     ? item.color.colorStops[0].color
                     : ""
                 } 0%, ${
                  typeof item.color == "object"
                    ? item.color.colorStops[1].color
                    : ""
                } 100%);"></span>
                 <span>${item.seriesName}</span>
                 <span style="float:right;color:#000000;margin-left:20px;">${
                   item.data + " " + this.put.unit[this.put.searchType]
                 }</span>
               </div>
             </div>`;
              } else {
                dataStr += `<div style=${
                  !item.data ? "display:none;" : "display:block"
                }>
               <div style="margin: 0 6px;">
                 <span style="display:inline-block;position:relative;width:8px;margin-right:5px;
                 ">
                <svg class="icon" style="position:absolute;top:-9px" viewBox="0 0 1024 1024" xmlns="http://www.w3.org/2000/svg" width="12" height="12"><path d="M682.667 307.2c17.066 0 34.133 17.067 34.133 34.133v341.334c0 17.066-17.067 34.133-34.133 34.133H341.333c-17.066 0-34.133-17.067-34.133-34.133V341.333c0-17.066 17.067-34.133 34.133-34.133h341.334m0-136.533H341.333c-93.866 0-170.666 76.8-170.666 170.666v341.334c0 93.866 76.8 170.666 170.666 170.666h341.334c93.866 0 170.666-76.8 170.666-170.666V341.333c0-93.866-76.8-170.666-170.666-170.666z" fill="${
                  item.color
                }"/></svg>
                 </span>
                 <span>${item.seriesName}</span>
                 <span style="float:right;color:#000000;margin-left:20px;">${
                   item.data
                 }</span>
               </div>
             </div>`;
              }
            });
            return dataStr;
          },
        },
        legend: {
          type: "scroll",
          bottom: 10,
          left: 30,
          itemHeight: 8,
          itemGap: 40,
          itemWidth: 8,
          textStyle: {
            //图例文字的样式
            fontSize: "12px",
            fontFamily: "SimSun",
            fontWeight: 400,
            color: "#9BA7BF",
          },
          pageTextStyle: {
            color: "#9BA7BF",
            fontSize: 12,
            fontFamily: "SimSun",
          },
          pageIconColor: "#AAAAAA", //翻页下一页的三角按钮颜色
          pageIconInactiveColor: "#333333", //翻页按钮不激活时（即翻页到头时）的颜色。
          pageIconSize: 11, //翻页按钮大小
          data: this.put.legend.data.map((item) => {
            if (item === "排塘率") {
              return {
                name: item,
                icon: "path://M682.666667 588.8c17.066667 0 34.133333-17.066667 34.133333-34.133333v-341.333334c0-17.066667-17.066667-34.133333-34.133333-34.133333H341.333333c-17.066667 0-34.133333 17.066667-34.133333 34.133333V554.666667c0 17.066667 17.066667 34.133333 34.133333 34.133333h341.333334M682.666667 725.333333H341.333333c-93.866667 0-170.666667-76.8-170.666666-170.666666v-341.333334c0-93.866667 76.8-170.666667 170.666666-170.666666h341.333334c93.866667 0 170.666667 76.8 170.666666 170.666666V554.666667c0 93.866667-76.8 170.666667-170.666666 170.666666z",
              };
            } else {
              return {
                name: item,
                icon: "path://M682.666667 725.333333H341.333333c-93.866667 0-170.666667-76.8-170.666666-170.666666v-341.333334c0-93.866667 76.8-170.666667 170.666666-170.666666h341.333334c93.866667 0 170.666667 76.8 170.666666 170.666666V554.666667c0 93.866667-76.8 170.666667-170.666666 170.666666z",
              };
            }
          }),
        },
        grid: {
          right: 30,
          top: 75,
          bottom: showBol ? 100 : 49,
          left: 30,
          width: "auto",
          containLabel: true,
        },
        dataZoom: [
          {
            dataBackground: {
              //未选中部分数据阴影样式
              lineStyle: {
                opacity: 0,
              },
              areaStyle: {
                opacity: 0,
              },
            },
            selectedDataBackground: {
              //选中部分数据阴影样式
              lineStyle: {
                opacity: 0,
              },
              areaStyle: {
                opacity: 0,
              },
            },
            type: "slider",
            show: showBol ? true : false,
            right: 41,
            bottom: showBol ? 60 : 35,
            height: 6,
            borderColor: "#383848", //缩放条边框颜色
            fillerColor: "#383848", //选中的阴影填充背景颜色
            backgroundColor: "rgb(30,30,43)", // 背景颜色
            maxValueSpan: 6,
            handleSize: 0,
            brushSelect: false,
            showDetail: false,
            moveHandleStyle: {},
          },
        ],
        xAxis: {
          type: "category",
          axisTick: {
            show: false,
          },
          axisLine: {
            show: true,
            lineStyle: {
              color: "#46494A",
            },
          },
          axisPointer: {
            type: "shadow",
          },
          axisLabel: {
            interval: 0,
            margin: 10,
            textStyle: {
              fontSize: 12,
              fontFamily: "SimSun",
              fontWeight: 400,
              color: "#838DA1",
            },
          },
          data: this.put.xAxis.data,
        },
        yAxis: [
          {
            type: "value",
            min: 0,
            axisLabel: {
              margin: 15,
              textStyle: {
                fontSize: 12,
                fontFamily: "SimSun",
                fontWeight: 400,
                color: "#838DA1",
              },
              formatter: "{value}",
            },
            splitLine: {
              show: true,
              // interval: 0,
              lineStyle: {
                color: "#46494A",
                type: [10, 10],
                dashOffset: 5,
              },
            },
          },
          {
            type: "value",
            interval: 10,
            axisLabel: {
              margin: 10,
              textStyle: {
                fontSize: 12,
                fontFamily: "SimSun",
                fontWeight: 400,
                color: "#838DA1",
              },
              formatter: "",
            },
            splitLine: {
              show: false,
            },
          },
        ],
        series: this.put.legend.data.map((item, idx) => {
          if (item === "排塘率") {
            return {
              name: this.put.series[`data${idx + 1}`].name,
              type: "line",
              yAxisIndex: 1,
              lineStyle: {
                color: this.lineColors[idx],
                width: 2,
              },
              emphasis: {
                focus: "series",
              },
              label: {
                show: showBol ? true : false,
                fontSize: 12,
                color: this.lineColors[idx],
                position: "top",
                distance: "30",
                formatter: (params) => {
                  return params.value + "%"; //随便写的值
                },
              },
              color: this.lineColors[idx],
              symbol: "none", //去掉折线图中的节点
              smooth: true, //true 为平滑曲线，false为直线
              connectNulls: true,
              showSymbol: this.put.xAxis.data.length == 1 ? true : false,
              data: this.put.series[`data${idx + 1}`].data,
            };
          } else {
            return {
              name: this.put.series[`data${idx + 1}`].name,
              type: "bar",
              tooltip: {
                valueFormatter: function (value) {
                  return value;
                },
              },
              barMaxWidth: showBol ? "10" : "4",
              barGap: showBol ? 1 : 3,
              label: {
                normal: {
                  show: showBol ? true : false,
                  position: "center",
                  textStyle: {
                    color: "white",
                    fontStyle: "normal",
                    fontFamily: "微软雅黑",
                    fontSize: 12,
                  },
                  // offset: [0, 0],
                  distance: "10",
                  rotate: "90",
                },
              },
              itemStyle: {
                color: new $echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  { offset: 1, color: this.barColors[idx][1] },
                  { offset: 0, color: this.barColors[idx][0] },
                ]),
                barBorderRadius: 50,
              },
              emphasis: {
                itemStyle: {
                  color: new $echarts.graphic.LinearGradient(0, 0, 0, 1, [
                    { offset: 1, color: this.barColors[idx][1] },
                    { offset: 0, color: this.barColors[idx][0] },
                  ]),
                },
              },
              data: this.put.series[`data${idx + 1}`].data,
            };
          }
        }),
      };
      if (option && typeof option === "object") {
        if (showBol) {
          this.isShowChart = true;
          setTimeout(() => {
            // 基于准备好的dom，初始化echarts实例
            this.showChart.chartDom = $echarts.init(
              document.getElementById(this.showChart.idName)
            );
            // this.annalsTarget.chartDom.setOption(option, this.animationDuration);
            this.showChart.chartDom.clear();
            if (this.showChart.searchType == "1") {
              this.closeFormatter(option);
              this.showChart.chartDom.setOption(option);
            } else {
              this.closeFormatter(option2);
              this.showChart.chartDom.setOption(option2);
            }
          });
          return;
        }
        // 基于准备好的dom，初始化echarts实例
        this.put.chartDom = $echarts.init(
          document.getElementById(this.put.idName)
        );
        // this.put.chartDom.setOption(option, this.animationDuration);
        this.put.chartDom.clear();
        if (this.put.searchType == "1") {
          this.put.chartDom.setOption(option);
          this.put.option = option;
        } else {
          this.put.chartDom.setOption(option2);
          this.put.option = option2;
        }
      }
    },
    // 存塘概览option
    storageChart(showBol) {
      // 指定图表的配置项和数据
      let option = {
        baseOption: {
          // backgroundColor: "#1E1E2B",
          timeline: {
            show: false,
            top: 0,
            data: [],
          },
          grid: [
            {
              show: false,
              left: "4%",
              top: showBol ? "7%" : "25%",
              bottom: showBol ? 100 : 49,
              containLabel: true,
              width: "37%",
            },
            {
              show: false,
              left: "51%",
              top: showBol ? "7%" : "25%",
              bottom: showBol ? 100 : 69,
              width: "0%",
            },
            {
              show: false,
              right: "4%",
              top: showBol ? "7%" : "25%",
              bottom: showBol ? 100 : 49,
              containLabel: true,
              width: "37.6%",
            },
          ],
          dataZoom: [
            {
              yAxisIndex: 0,
              dataBackground: {
                //未选中部分数据阴影样式
                lineStyle: {
                  opacity: 0,
                },
                areaStyle: {
                  opacity: 0,
                },
              },
              selectedDataBackground: {
                //选中部分数据阴影样式
                lineStyle: {
                  opacity: 0,
                },
                areaStyle: {
                  opacity: 0,
                },
              },
              type: "slider",
              show: false,
              right: 42,
              bottom: showBol ? 60 : 35,
              height: 6,
              borderColor: "#383848", //缩放条边框颜色
              fillerColor: "#383848", //选中的阴影填充背景颜色
              backgroundColor: "rgb(30,30,43)", // 背景颜色
              maxValueSpan: 3,
              handleSize: 0,
              brushSelect: false,
              showDetail: false,
              moveHandleStyle: {},
            },
            {
              yAxisIndex: 1,
              dataBackground: {
                //未选中部分数据阴影样式
                lineStyle: {
                  opacity: 0,
                },
                areaStyle: {
                  opacity: 0,
                },
              },
              selectedDataBackground: {
                //选中部分数据阴影样式
                lineStyle: {
                  opacity: 0,
                },
                areaStyle: {
                  opacity: 0,
                },
              },
              type: "slider",
              show: false,
              right: 42,
              bottom: 35,
              height: 6,
              borderColor: "#383848", //缩放条边框颜色
              fillerColor: "#383848", //选中的阴影填充背景颜色
              backgroundColor: "rgb(30,30,43)", // 背景颜色
              maxValueSpan: 3,
              handleSize: 0,
              brushSelect: false,
              showDetail: false,
              moveHandleStyle: {},
            },
            {
              yAxisIndex: 2,
              dataBackground: {
                //未选中部分数据阴影样式
                lineStyle: {
                  opacity: 0,
                },
                areaStyle: {
                  opacity: 0,
                },
              },
              selectedDataBackground: {
                //选中部分数据阴影样式
                lineStyle: {
                  opacity: 0,
                },
                areaStyle: {
                  opacity: 0,
                },
              },
              type: "slider",
              show: false,
              right: 42,
              bottom: 35,
              height: 6,
              borderColor: "#383848", //缩放条边框颜色
              fillerColor: "#383848", //选中的阴影填充背景颜色
              backgroundColor: "rgb(30,30,43)", // 背景颜色
              maxValueSpan: 3,
              handleSize: 0,
              brushSelect: false,
              showDetail: false,
              moveHandleStyle: {},
            },
          ],
          tooltip: {
            trigger: "axis",
            axisPointer: {
              type: "cross",
              crossStyle: {
                color: "#999",
              },
              label: {
                padding: [5, 13, 5, 13],
              },
            },
            textStyle: {
              color: "#111E39",
              fontSize: 12,
              fontFamily: "Microsoft YaHei",
              fontWeight: 400,
            },
            formatter: (params) => {
              let dataStr = `<div><p style="font-weight:bold;margin:0 8px 10px;">${params[0].name}</p></div>`;
              params.forEach((item, i) => {
                if (item.seriesName.indexOf("塘口数") > -1) {
                  dataStr += `<div style=${
                    !item.data ? "display:none;" : "display:block"
                  }>
          <div style="margin: 0 8px;">
            <span style="display:inline-block;margin-right:4px;width:8px;height:8px;border-radius:2px;background:linear-gradient(0deg, ${
              item.color.colorStops[0].color
            } 0%, ${item.color.colorStops[1].color} 100%);"></span>
            <span>${item.seriesName}</span>
            <span style="float:right;color:#000000;margin-left:20px;">${
              item.data
            } 口</span>
          </div>
        </div>`;
                } else {
                  dataStr += `<div style=${
                    !item.data ? "display:none;" : "display:block"
                  }>
          <div style="margin: 0 8px;">
            <span style="display:inline-block;margin-right:4px;width:8px;height:8px;border-radius:2px;background:linear-gradient(0deg, ${
              item.color.colorStops[0].color
            } 0%, ${item.color.colorStops[1].color} 100%);"></span>
            <span>${item.seriesName}</span>
            <span style="float:right;color:#000000;margin-left:20px;">${
              item.data
            } 尾</span>
          </div>
        </div>`;
                }
              });
              return dataStr;
            },
          },
          legend: {
            type: "scroll",
            bottom: 10,
            left: 30,
            itemHeight: 8,
            itemGap: 40,
            itemWidth: 8,
            pageTextStyle: {
              color: "#9BA7BF",
              fontSize: 12,
              fontFamily: "SimSun",
            },
            pageIconColor: "#AAAAAA", //翻页下一页的三角按钮颜色
            pageIconInactiveColor: "#333333", //翻页按钮不激活时（即翻页到头时）的颜色。
            pageIconSize: 11, //翻页按钮大小
            data: this.storage.legend.data.map((re) => {
              return {
                name: re,
                textStyle: {
                  fontSize: 12,
                  fontFamily: "SimSun",
                  fontWeight: 400,
                  color: "#9BA7BF",
                },
                icon: "path://M682.666667 725.333333H341.333333c-93.866667 0-170.666667-76.8-170.666666-170.666666v-341.333334c0-93.866667 76.8-170.666667 170.666666-170.666666h341.333334c93.866667 0 170.666667 76.8 170.666666 170.666666V554.666667c0 93.866667-76.8 170.666667-170.666666 170.666666z",
              };
            }),
          },
          xAxis: [
            {
              type: "value",
              inverse: true,
              axisLine: {
                show: false,
              },
              axisTick: {
                show: false,
              },
              position: "bottom",
              axisLabel: {
                show: true,
                color: "#838DA1",
                hideOverlap: true,
              },
              splitLine: {
                show: true,
                lineStyle: {
                  color: "#46494A",
                },
              },
            },
            {
              gridIndex: 1,
              show: false,
            },
            {
              gridIndex: 2,
              axisLine: {
                show: false,
              },
              axisTick: {
                show: false,
              },
              position: "bottom",
              axisLabel: {
                show: true,
                color: "#838DA1",
                hideOverlap: true,
              },
              splitLine: {
                show: true,
                lineStyle: {
                  color: "#46494A",
                },
              },
            },
          ],
          yAxis: [
            {
              type: "category",
              inverse: true,
              position: "right",
              boundaryGap: true,
              axisPointer: {
                type: "shadow",
              },
              axisLine: {
                show: true,
                lineStyle: {
                  color: "#46494A",
                },
              },
              axisTick: {
                show: false,
              },
              axisLabel: {
                show: false,
              },
              data: this.storage.xAxis.data,
            },
            {
              gridIndex: 1,
              type: "category",
              inverse: true,
              position: "left",
              axisLine: {
                show: false,
              },
              axisTick: {
                show: false,
              },
              axisLabel: {
                show: true,
                padding: [30, 30, 30, 30],
                textStyle: {
                  color: "#838DA1",
                  fontSize: 12,
                },
                align: "center",
              },
              data: this.storage.xAxis.data.map(function (value) {
                return {
                  value: value,
                  textStyle: {
                    align: "center",
                  },
                };
              }),
            },
            {
              gridIndex: 2,
              type: "category",
              inverse: true,
              position: "left",
              boundaryGap: true,
              axisPointer: {
                type: "shadow",
              },
              axisLine: {
                show: true,
                lineStyle: {
                  color: "#46494A",
                },
              },
              axisTick: {
                show: false,
              },
              axisLabel: {
                show: false,
              },
              data: this.storage.xAxis.data,
            },
          ],
          series: [],
        },
        options: [
          {
            series: this.storage.legend.data.map((item, idx) => {
              if (item.includes("存塘量")) {
                return {
                  name: this.storage.series[`data${idx + 1}`].name,
                  type: "bar",
                  xAxisIndex: 2,
                  yAxisIndex: 2,
                  tooltip: {
                    valueFormatter: function (value) {
                      return value;
                    },
                  },
                  itemStyle: {
                    color: new $echarts.graphic.LinearGradient(0, 0, 0, 1, [
                      { offset: 1, color: this.barColors[idx][1] },
                      { offset: 0, color: this.barColors[idx][0] },
                    ]),
                    barBorderRadius: 50,
                  },
                  emphasis: {
                    itemStyle: {
                      color: new $echarts.graphic.LinearGradient(0, 0, 0, 1, [
                        { offset: 1, color: this.barColors[idx][1] },
                        { offset: 0, color: this.barColors[idx][0] },
                      ]),
                    },
                  },
                  barMaxWidth: showBol ? "6" : "4",
                  barGap: showBol ? 1 : 3,
                  label: {
                    normal: {
                      show: showBol ? true : false,
                      textStyle: {
                        color: "white",
                        fontStyle: "normal",
                        fontFamily: "微软雅黑",
                        fontSize: 10,
                      },
                      position: "right",
                      formatter: (param) => {
                        if (param.value == 0) {
                          return ``;
                        }
                        return param.value;
                      },
                    },
                  },
                  data: this.storage.series[`data${idx + 1}`].data,
                };
              } else {
                return {
                  name: this.storage.series[`data${idx + 1}`].name,
                  type: "bar",
                  tooltip: {
                    valueFormatter: function (value) {
                      return value;
                    },
                  },
                  itemStyle: {
                    color: new $echarts.graphic.LinearGradient(0, 0, 0, 1, [
                      { offset: 1, color: this.barColors[idx][1] },
                      { offset: 0, color: this.barColors[idx][0] },
                    ]),
                    barBorderRadius: 50,
                  },
                  emphasis: {
                    itemStyle: {
                      color: new $echarts.graphic.LinearGradient(0, 0, 0, 1, [
                        { offset: 1, color: this.barColors[idx][1] },
                        { offset: 0, color: this.barColors[idx][0] },
                      ]),
                    },
                  },
                  barMaxWidth: showBol ? "6" : "4",
                  barGap: showBol ? 1 : 3,
                  label: {
                    normal: {
                      show: showBol ? true : false,
                      textStyle: {
                        color: "white",
                        fontStyle: "normal",
                        fontFamily: "微软雅黑",
                        fontSize: 10,
                      },
                      position: "left",
                      formatter: (param) => {
                        if (param.value == 0) {
                          return ``;
                        }
                        return param.value;
                      },
                    },
                  },
                  data: this.storage.series[`data${idx + 1}`].data,
                };
              }
            }),
          },
        ],
      };
      let option2 = {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross",
            crossStyle: {
              color: "#999",
            },
          },
          textStyle: {
            color: "#111E39",
            fontSize: 12,
            fontFamily: "Microsoft YaHei",
            fontWeight: 400,
          },
          formatter: (params) => {
            let dataStr = `<div><p style="font-weight:bold;margin:0 8px 10px;">${params[0].name}</p></div>`;
            params.forEach((item, i) => {
              dataStr += `<div style=${
                !item.data ? "display:none;" : "display:block"
              }>
          <div style="margin: 0 8px;">
            <span style="display:inline-block;margin-right:4px;width:8px;height:8px;border-radius:2px;background:linear-gradient(0deg, ${
              item.color.colorStops[0].color
            } 0%, ${item.color.colorStops[1].color} 100%);"></span>
            <span>${item.seriesName}</span>
            <span style="float:right;color:#000000;margin-left:20px;">${
              item.data + " " + this.storage.unit[this.storage.searchType]
            }</span>
          </div>
        </div>`;
            });
            return dataStr;
          },
        },
        legend: {
          type: "scroll",
          bottom: 10,
          left: 30,
          itemHeight: 8,
          itemGap: 40,
          itemWidth: 8,
          textStyle: {
            //图例文字的样式
            fontSize: "12px",
            fontFamily: "SimSun",
            fontWeight: 400,
            color: "#9BA7BF",
          },
          pageTextStyle: {
            color: "#9BA7BF",
            fontSize: 12,
            fontFamily: "SimSun",
          },
          pageIconColor: "#AAAAAA", //翻页下一页的三角按钮颜色
          pageIconInactiveColor: "#333333", //翻页按钮不激活时（即翻页到头时）的颜色。
          pageIconSize: 11, //翻页按钮大小
          data: this.storage.legend.data.map((item) => {
            return {
              name: item,
              icon: "path://M682.666667 725.333333H341.333333c-93.866667 0-170.666667-76.8-170.666666-170.666666v-341.333334c0-93.866667 76.8-170.666667 170.666666-170.666666h341.333334c93.866667 0 170.666667 76.8 170.666666 170.666666V554.666667c0 93.866667-76.8 170.666667-170.666666 170.666666z",
            };
          }),
        },
        grid: {
          right: 30,
          top: 75,
          bottom: showBol ? 100 : 49,
          left: 30,
          width: "auto",
          containLabel: true,
        },
        dataZoom: [
          {
            dataBackground: {
              //未选中部分数据阴影样式
              lineStyle: {
                opacity: 0,
              },
              areaStyle: {
                opacity: 0,
              },
            },
            selectedDataBackground: {
              //选中部分数据阴影样式
              lineStyle: {
                opacity: 0,
              },
              areaStyle: {
                opacity: 0,
              },
            },
            type: "slider",
            show: showBol ? true : false,
            right: 33,
            bottom: showBol ? 60 : 35,
            height: 6,
            borderColor: "#383848", //缩放条边框颜色
            fillerColor: "#383848", //选中的阴影填充背景颜色
            backgroundColor: "rgb(30,30,43)", // 背景颜色
            maxValueSpan: 6,
            handleSize: 0,
            brushSelect: false,
            showDetail: false,
            moveHandleStyle: {},
          },
        ],
        xAxis: [
          {
            type: "category",
            data: this.storage.xAxis.data,
            axisPointer: {
              type: "shadow",
            },
            axisLabel: {
              interval: 0,
              margin: 10,
              textStyle: {
                fontSize: 12,
                fontFamily: "SimSun",
                fontWeight: 400,
                color: "#838DA1",
              },
            },
            axisTick: {
              // x轴刻度线
              show: false,
            },
            axisLine: {
              show: true,
              lineStyle: {
                color: "#46494A",
              },
            },
          },
        ],
        yAxis: [
          {
            type: "value",
            min: 0,
            axisLabel: {
              margin: 15,
              textStyle: {
                fontSize: 12,
                fontFamily: "SimSun",
                fontWeight: 400,
                color: "#838DA1",
              },
              formatter: "{value}",
            },
            splitLine: {
              show: true,
              lineStyle: {
                color: "#46494A",
                type: [10, 10],
                dashOffset: 5,
              },
            },
          },
        ],
        series: this.storage.legend.data.map((item, idx) => {
          return {
            name: this.storage.series[`data${idx + 1}`].name,
            type: "bar",
            tooltip: {
              valueFormatter: function (value) {
                return value;
              },
            },
            barMaxWidth: showBol ? "10" : "4",
            barGap: showBol ? 1 : 3,
            label: {
              normal: {
                show: showBol ? true : false,
                position: "center",
                textStyle: {
                  color: "white",
                  fontStyle: "normal",
                  fontFamily: "微软雅黑",
                  fontSize: 12,
                },
                // offset: [0, 0],
                distance: "10",
                rotate: "90",
                formatter: (param) => {
                  if (param.value == 0) {
                    return ``;
                  }
                  return param.value;
                },
              },
            },
            itemStyle: {
              color: new $echarts.graphic.LinearGradient(0, 0, 0, 1, [
                { offset: 1, color: this.barColors[idx][1] },
                { offset: 0, color: this.barColors[idx][0] },
              ]),
              barBorderRadius: 50,
            },
            emphasis: {
              itemStyle: {
                color: new $echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  { offset: 1, color: this.barColors[idx][1] },
                  { offset: 0, color: this.barColors[idx][0] },
                ]),
              },
            },
            data: this.storage.series[`data${idx + 1}`].data,
          };
        }),
      };
      if (option && typeof option === "object") {
        if (showBol) {
          this.isShowChart = true;
          setTimeout(() => {
            // 基于准备好的dom，初始化echarts实例
            this.showChart.chartDom = $echarts.init(
              document.getElementById(this.showChart.idName)
            );
            // this.annalsTarget.chartDom.setOption(option, this.animationDuration);
            this.showChart.chartDom.clear();
            if (this.showChart.searchType == "1") {
              this.closeFormatter(option);
              this.showChart.chartDom.setOption(option);
              this.isDataZoomShow = true;
              this.showChart.option = option;
            } else {
              this.closeFormatter(option2);
              this.isDataZoomShow = false;
              this.showChart.chartDom.setOption(option2);
            }
          });
          return;
        }
        // 基于准备好的dom，初始化echarts实例
        this.storage.chartDom = $echarts.init(
          document.getElementById(this.storage.idName)
        );
        // this.storage.chartDom.setOption(option, this.animationDuration);
        this.storage.chartDom.clear();
        if (this.storage.searchType == "1") {
          this.storage.chartDom.setOption(option);
          this.storage.option = option;
        } else {
          this.storage.chartDom.setOption(option2);
          this.storage.option = option2;
        }
      }
    },
    // 销售概览option
    salesChart(showBol) {
      // 指定图表的配置项和数据
      let option = {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross",
            crossStyle: {
              color: "#999",
            },
          },
          textStyle: {
            color: "#111E39",
            fontSize: 12,
            fontFamily: "Microsoft YaHei",
            fontWeight: 400,
          },
          formatter: (params) => {
            let dataStr = `<div><p style="font-weight:bold;margin:0 8px 10px;">${params[0].name}</p></div>`;
            params.forEach((item, i) => {
              dataStr += `<div style=${
                !item.data ? "display:none;" : "display:block"
              }>
          <div style="margin: 0 8px;">
            <span style="display:inline-block;margin-right:4px;width:8px;height:8px;border-radius:2px;background:linear-gradient(0deg, ${
              item.color.colorStops[0].color
            } 0%, ${item.color.colorStops[1].color} 100%);"></span>
            <span>${item.seriesName}</span>
            <span style="float:right;color:#000000;margin-left:20px;">${
              item.data + " " + this.sales.unit[this.sales.searchType]
            }</span>
          </div>
        </div>`;
            });
            return dataStr;
          },
        },
        legend: {
          type: "scroll",
          bottom: 10,
          left: 30,
          itemHeight: 8,
          itemGap: 40,
          itemWidth: 8,
          textStyle: {
            //图例文字的样式
            fontSize: "12px",
            fontFamily: "SimSun",
            fontWeight: 400,
            color: "#9BA7BF",
          },
          pageTextStyle: {
            color: "#9BA7BF",
            fontSize: 12,
            fontFamily: "SimSun",
          },
          pageIconColor: "#AAAAAA", //翻页下一页的三角按钮颜色
          pageIconInactiveColor: "#333333", //翻页按钮不激活时（即翻页到头时）的颜色。
          pageIconSize: 11, //翻页按钮大小
          data: this.sales.legend.data.map((item) => {
            return {
              name: item,
              icon: "path://M682.666667 725.333333H341.333333c-93.866667 0-170.666667-76.8-170.666666-170.666666v-341.333334c0-93.866667 76.8-170.666667 170.666666-170.666666h341.333334c93.866667 0 170.666667 76.8 170.666666 170.666666V554.666667c0 93.866667-76.8 170.666667-170.666666 170.666666z",
            };
          }),
        },
        grid: {
          right: 30,
          top: 70,
          bottom: showBol ? 100 : 49,
          left: 30,
          width: "auto",
          containLabel: true,
        },
        dataZoom: [
          {
            dataBackground: {
              //未选中部分数据阴影样式
              lineStyle: {
                opacity: 0,
              },
              areaStyle: {
                opacity: 0,
              },
            },
            selectedDataBackground: {
              //选中部分数据阴影样式
              lineStyle: {
                opacity: 0,
              },
              areaStyle: {
                opacity: 0,
              },
            },
            type: "slider",
            show: showBol ? true : false,
            right: 33,
            bottom: showBol ? 60 : 35,
            height: 6,
            borderColor: "#383848", //缩放条边框颜色
            fillerColor: "#383848", //选中的阴影填充背景颜色
            backgroundColor: "rgb(30,30,43)", // 背景颜色
            maxValueSpan: 6,
            handleSize: 0,
            brushSelect: false,
            showDetail: false,
            moveHandleStyle: {},
          },
        ],
        xAxis: [
          {
            type: "category",
            data: this.sales.xAxis.data,
            axisPointer: {
              type: "shadow",
            },
            axisLabel: {
              interval: 0,
              margin: 10,
              textStyle: {
                fontSize: 12,
                fontFamily: "SimSun",
                fontWeight: 400,
                color: "#838DA1",
              },
            },
            axisTick: {
              // x轴刻度线
              show: false,
            },
            axisLine: {
              show: true,
              lineStyle: {
                color: "#46494A",
              },
            },
          },
        ],
        yAxis: [
          {
            type: "value",
            min: 0,
            axisLabel: {
              margin: 15,
              textStyle: {
                fontSize: 12,
                fontFamily: "SimSun",
                fontWeight: 400,
                color: "#838DA1",
              },
              formatter: "{value}",
            },
            splitLine: {
              show: true,
              lineStyle: {
                color: "#46494A",
                type: [10, 10],
                dashOffset: 5,
              },
            },
          },
        ],
        series: this.sales.legend.data.map((item, idx) => {
          return {
            name: this.sales.series[`data${idx + 1}`].name,
            type: "bar",
            tooltip: {
              valueFormatter: function (value) {
                return value;
              },
            },
            barMaxWidth: showBol ? "10" : "4",
            barGap: showBol ? 1 : 3,
            label: {
              normal: {
                show: showBol ? true : false,
                position: "center",
                textStyle: {
                  color: "white",
                  fontStyle: "normal",
                  fontFamily: "微软雅黑",
                  fontSize: 12,
                },
                // offset: [0, 0],
                distance: "10",
                rotate: "90",
                formatter: (param) => {
                  if (param.value == 0) {
                    return ``;
                  }
                  return param.value;
                },
              },
            },
            itemStyle: {
              color: new $echarts.graphic.LinearGradient(0, 0, 0, 1, [
                { offset: 1, color: this.barColors[idx][1] },
                { offset: 0, color: this.barColors[idx][0] },
              ]),
              barBorderRadius: 50,
            },
            emphasis: {
              itemStyle: {
                color: new $echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  { offset: 1, color: this.barColors[idx][1] },
                  { offset: 0, color: this.barColors[idx][0] },
                ]),
              },
            },
            data: this.sales.series[`data${idx + 1}`].data,
          };
        }),
      };
      let option2 = {
        baseOption: {
          // backgroundColor: "#1E1E2B",
          timeline: {
            show: false,
            top: 0,
            data: [],
          },
          grid: [
            {
              show: false,
              left: "4%",
              top: showBol ? "7" : "25%",
              bottom: showBol ? 100 : 49,
              containLabel: true,
              width: "37%",
            },
            {
              show: false,
              left: "51%",
              top: showBol ? "7" : "25%",
              bottom: showBol ? 100 : 49,
              width: "0%",
            },
            {
              show: false,
              right: "4%",
              top: showBol ? "7" : "25%",
              bottom: showBol ? 100 : 49,
              containLabel: true,
              width: "37.6%",
            },
          ],
          dataZoom: [
            {
              yAxisIndex: 0,
              dataBackground: {
                //未选中部分数据阴影样式
                lineStyle: {
                  opacity: 0,
                },
                areaStyle: {
                  opacity: 0,
                },
              },
              selectedDataBackground: {
                //选中部分数据阴影样式
                lineStyle: {
                  opacity: 0,
                },
                areaStyle: {
                  opacity: 0,
                },
              },
              type: "slider",
              show: false,
              right: 42,
              bottom: 35,
              height: 6,
              borderColor: "#383848", //缩放条边框颜色
              fillerColor: "#383848", //选中的阴影填充背景颜色
              backgroundColor: "rgb(30,30,43)", // 背景颜色
              maxValueSpan: 3,
              handleSize: 0,
              brushSelect: false,
              showDetail: false,
              moveHandleStyle: {},
            },
            {
              yAxisIndex: 1,
              dataBackground: {
                //未选中部分数据阴影样式
                lineStyle: {
                  opacity: 0,
                },
                areaStyle: {
                  opacity: 0,
                },
              },
              selectedDataBackground: {
                //选中部分数据阴影样式
                lineStyle: {
                  opacity: 0,
                },
                areaStyle: {
                  opacity: 0,
                },
              },
              type: "slider",
              show: false,
              right: 42,
              bottom: 35,
              height: 6,
              borderColor: "#383848", //缩放条边框颜色
              fillerColor: "#383848", //选中的阴影填充背景颜色
              backgroundColor: "rgb(30,30,43)", // 背景颜色
              maxValueSpan: 3,
              handleSize: 0,
              brushSelect: false,
              showDetail: false,
              moveHandleStyle: {},
            },
            {
              yAxisIndex: 2,
              dataBackground: {
                //未选中部分数据阴影样式
                lineStyle: {
                  opacity: 0,
                },
                areaStyle: {
                  opacity: 0,
                },
              },
              selectedDataBackground: {
                //选中部分数据阴影样式
                lineStyle: {
                  opacity: 0,
                },
                areaStyle: {
                  opacity: 0,
                },
              },
              type: "slider",
              show: false,
              right: 42,
              bottom: 35,
              height: 6,
              borderColor: "#383848", //缩放条边框颜色
              fillerColor: "#383848", //选中的阴影填充背景颜色
              backgroundColor: "rgb(30,30,43)", // 背景颜色
              maxValueSpan: 3,
              handleSize: 0,
              brushSelect: false,
              showDetail: false,
              moveHandleStyle: {},
            },
          ],
          tooltip: {
            trigger: "axis",
            axisPointer: {
              type: "cross",
              crossStyle: {
                color: "#999",
              },
              label: {
                padding: [5, 13, 5, 13],
              },
            },
            textStyle: {
              color: "#111E39",
              fontSize: 12,
              fontFamily: "Microsoft YaHei",
              fontWeight: 400,
            },
            formatter: (params) => {
              let dataStr = `<div><p style="font-weight:bold;margin:0 8px 10px;">${params[0].name}</p></div>`;
              params.forEach((item, i) => {
                if (item.seriesName.indexOf("平均价格") > -1) {
                  dataStr += `<div style=${
                    !item.data ? "display:none;" : "display:block"
                  }>
          <div style="margin: 0 8px;">
            <span style="display:inline-block;margin-right:4px;width:8px;height:8px;border-radius:2px;background:linear-gradient(0deg, ${
              item.color.colorStops[0].color
            } 0%, ${item.color.colorStops[1].color} 100%);"></span>
            <span>${item.seriesName}</span>
            <span style="float:right;color:#000000;margin-left:20px;">${
              item.data
            } 元/斤</span>
          </div>
        </div>`;
                } else {
                  dataStr += `<div style=${
                    !item.data ? "display:none;" : "display:block"
                  }>
          <div style="margin: 0 8px;">
            <span style="display:inline-block;margin-right:4px;width:8px;height:8px;border-radius:2px;background:linear-gradient(0deg, ${
              item.color.colorStops[0].color
            } 0%, ${item.color.colorStops[1].color} 100%);"></span>
            <span>${item.seriesName}</span>
            <span style="float:right;color:#000000;margin-left:20px;">${
              item.data
            } 斤</span>
          </div>
        </div>`;
                }
              });
              return dataStr;
            },
          },
          legend: {
            type: "scroll",
            bottom: 10,
            left: 30,
            itemHeight: 8,
            itemGap: 40,
            itemWidth: 8,
            pageTextStyle: {
              color: "#9BA7BF",
              fontSize: 12,
              fontFamily: "SimSun",
            },
            pageIconColor: "#AAAAAA", //翻页下一页的三角按钮颜色
            pageIconInactiveColor: "#333333", //翻页按钮不激活时（即翻页到头时）的颜色。
            pageIconSize: 11, //翻页按钮大小
            data: this.sales.legend.data.map((re) => {
              return {
                name: re,
                textStyle: {
                  fontSize: 12,
                  fontFamily: "SimSun",
                  fontWeight: 400,
                  color: "#9BA7BF",
                },
                icon: "path://M682.666667 725.333333H341.333333c-93.866667 0-170.666667-76.8-170.666666-170.666666v-341.333334c0-93.866667 76.8-170.666667 170.666666-170.666666h341.333334c93.866667 0 170.666667 76.8 170.666666 170.666666V554.666667c0 93.866667-76.8 170.666667-170.666666 170.666666z",
              };
            }),
          },
          xAxis: [
            {
              type: "value",
              inverse: true,
              axisLine: {
                show: false,
              },
              axisTick: {
                show: false,
              },
              position: "bottom",
              axisLabel: {
                show: true,
                color: "#838DA1",
                hideOverlap: true,
              },
              splitLine: {
                show: true,
                lineStyle: {
                  color: "#46494A",
                },
              },
            },
            {
              gridIndex: 1,
              show: false,
            },
            {
              gridIndex: 2,
              axisLine: {
                show: false,
              },
              axisTick: {
                show: false,
              },
              position: "bottom",
              axisLabel: {
                show: true,
                color: "#838DA1",
                hideOverlap: true,
              },
              splitLine: {
                show: true,
                lineStyle: {
                  color: "#46494A",
                },
              },
            },
          ],
          yAxis: [
            {
              type: "category",
              inverse: true,
              position: "right",
              boundaryGap: true,
              axisPointer: {
                type: "shadow",
              },
              axisLine: {
                show: true,
                lineStyle: {
                  color: "#46494A",
                },
              },
              axisTick: {
                show: false,
              },
              axisLabel: {
                show: false,
              },
              data: this.sales.xAxis.data,
            },
            {
              gridIndex: 1,
              type: "category",
              inverse: true,
              position: "left",
              axisLine: {
                show: false,
              },
              axisTick: {
                show: false,
              },
              axisLabel: {
                show: true,
                padding: [30, 30, 30, 30],
                textStyle: {
                  color: "#838DA1",
                  fontSize: 12,
                },
                align: "center",
              },
              data: this.sales.xAxis.data.map(function (value) {
                return {
                  value: value,
                  textStyle: {
                    align: "center",
                  },
                };
              }),
            },
            {
              gridIndex: 2,
              type: "category",
              inverse: true,
              position: "left",
              boundaryGap: true,
              axisPointer: {
                type: "shadow",
              },
              axisLine: {
                show: true,
                lineStyle: {
                  color: "#46494A",
                },
              },
              axisTick: {
                show: false,
              },
              axisLabel: {
                show: false,
              },
              data: this.sales.xAxis.data,
            },
          ],
          series: [],
        },
        options: [
          {
            series: this.sales.legend.data.map((item, idx) => {
              if (item.includes("平均价格")) {
                return {
                  name: this.sales.series[`data${idx + 1}`].name,
                  type: "bar",
                  tooltip: {
                    valueFormatter: function (value) {
                      return value;
                    },
                  },
                  itemStyle: {
                    color: new $echarts.graphic.LinearGradient(0, 0, 0, 1, [
                      { offset: 1, color: this.barColors[idx][1] },
                      { offset: 0, color: this.barColors[idx][0] },
                    ]),
                    barBorderRadius: 50,
                  },
                  emphasis: {
                    itemStyle: {
                      color: new $echarts.graphic.LinearGradient(0, 0, 0, 1, [
                        { offset: 1, color: this.barColors[idx][1] },
                        { offset: 0, color: this.barColors[idx][0] },
                      ]),
                    },
                  },
                  barMaxWidth: showBol ? "7" : "5",
                  barGap: showBol ? 0 : 3,
                  label: {
                    normal: {
                      show: showBol ? true : false,
                      textStyle: {
                        color: "white",
                        fontStyle: "normal",
                        fontFamily: "微软雅黑",
                        fontSize: 10,
                      },
                      position: item.yAxisIndex ? "right" : "left",
                      // offset: [0, 0],
                      // distance: "-300",
                      // rotate: "90",
                      formatter: (param) => {
                        if (param.value == 0) {
                          return ``;
                        }
                        return param.value;
                      },
                    },
                  },
                  animationEasing: "elasticOut",
                  data: this.sales.series[`data${idx + 1}`].data,
                };
              } else {
                return {
                  name: this.sales.series[`data${idx + 1}`].name,
                  type: "bar",
                  xAxisIndex: 2,
                  yAxisIndex: 2,
                  tooltip: {
                    valueFormatter: function (value) {
                      return value;
                    },
                  },
                  itemStyle: {
                    color: new $echarts.graphic.LinearGradient(0, 0, 0, 1, [
                      { offset: 1, color: this.barColors[idx][1] },
                      { offset: 0, color: this.barColors[idx][0] },
                    ]),
                    barBorderRadius: 50,
                  },
                  emphasis: {
                    itemStyle: {
                      color: new $echarts.graphic.LinearGradient(0, 0, 0, 1, [
                        { offset: 1, color: this.barColors[idx][1] },
                        { offset: 0, color: this.barColors[idx][0] },
                      ]),
                    },
                  },
                  barMaxWidth: showBol ? "7" : "5",
                  barGap: showBol ? 0 : 3,
                  label: {
                    normal: {
                      show: showBol ? true : false,
                      textStyle: {
                        color: "white",
                        fontStyle: "normal",
                        fontFamily: "微软雅黑",
                        fontSize: 10,
                      },
                      position: "right",
                      // offset: [0, 0],
                      // distance: "-300",
                      // rotate: "90",
                      formatter: (param) => {
                        if (param.value == 0) {
                          return ``;
                        }
                        return param.value;
                      },
                    },
                  },
                  animationEasing: "elasticOut",
                  data: this.sales.series[`data${idx + 1}`].data,
                };
              }
            }),
          },
        ],
      };
      let option3 = {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross",
            crossStyle: {
              color: "#999",
            },
          },
          textStyle: {
            color: "#111E39",
            fontSize: 12,
            fontFamily: "Microsoft YaHei",
            fontWeight: 400,
          },
          formatter: (params) => {
            let dataStr = `<div><p style="font-weight:bold;margin:0 8px 10px;">${params[0].name}</p></div>`;
            params.forEach((item, i) => {
              if (item.seriesName.includes("应收款")) {
                dataStr += `<div style=${
                  !item.data ? "display:none;" : "display:block"
                }>
               <div style="margin: 0 8px;">
                 <span style="display:inline-block;margin-right:4px;width:8px;height:8px;border-radius:2px;background:linear-gradient(0deg, ${
                   typeof item.color == "object"
                     ? item.color.colorStops[0].color
                     : ""
                 } 0%, ${
                  typeof item.color == "object"
                    ? item.color.colorStops[1].color
                    : ""
                } 100%);"></span>
                 <span>${item.seriesName}</span>
                 <span style="float:right;color:#000000;margin-left:20px;">${
                   item.data + " " + this.sales.unit[this.sales.searchType]
                 }</span>
               </div>
             </div>`;
              } else {
                dataStr += `<div style=${
                  !item.data ? "display:none;" : "display:block"
                }>
               <div style="margin: 0 6px;">
                 <span style="display:inline-block;position:relative;width:8px;margin-right:5px;
                 ">
                <svg class="icon" style="position:absolute;top:-9px" viewBox="0 0 1024 1024" xmlns="http://www.w3.org/2000/svg" width="12" height="12"><path d="M682.667 307.2c17.066 0 34.133 17.067 34.133 34.133v341.334c0 17.066-17.067 34.133-34.133 34.133H341.333c-17.066 0-34.133-17.067-34.133-34.133V341.333c0-17.066 17.067-34.133 34.133-34.133h341.334m0-136.533H341.333c-93.866 0-170.666 76.8-170.666 170.666v341.334c0 93.866 76.8 170.666 170.666 170.666h341.334c93.866 0 170.666-76.8 170.666-170.666V341.333c0-93.866-76.8-170.666-170.666-170.666z" fill="${
                  item.color
                }"/></svg>
                 </span>
                 <span>${item.seriesName}</span>
                 <span style="float:right;color:#000000;margin-left:20px;">${
                   item.data
                 } %</span>
               </div>
             </div>`;
              }
            });
            return dataStr;
          },
        },
        legend: {
          type: "scroll",
          bottom: 10,
          left: 30,
          itemHeight: 8,
          itemGap: 40,
          itemWidth: 8,
          textStyle: {
            //图例文字的样式
            fontSize: "12px",
            fontFamily: "SimSun",
            fontWeight: 400,
            color: "#9BA7BF",
          },
          pageTextStyle: {
            color: "#9BA7BF",
            fontSize: 12,
            fontFamily: "SimSun",
          },
          pageIconColor: "#AAAAAA", //翻页下一页的三角按钮颜色
          pageIconInactiveColor: "#333333", //翻页按钮不激活时（即翻页到头时）的颜色。
          pageIconSize: 11, //翻页按钮大小
          data: this.sales.legend.data.map((item) => {
            if (item.includes("应收款")) {
              return {
                name: item,
                icon: "path://M682.666667 725.333333H341.333333c-93.866667 0-170.666667-76.8-170.666666-170.666666v-341.333334c0-93.866667 76.8-170.666667 170.666666-170.666666h341.333334c93.866667 0 170.666667 76.8 170.666666 170.666666V554.666667c0 93.866667-76.8 170.666667-170.666666 170.666666z",
              };
            } else {
              return {
                name: item,
                icon: "path://M682.666667 588.8c17.066667 0 34.133333-17.066667 34.133333-34.133333v-341.333334c0-17.066667-17.066667-34.133333-34.133333-34.133333H341.333333c-17.066667 0-34.133333 17.066667-34.133333 34.133333V554.666667c0 17.066667 17.066667 34.133333 34.133333 34.133333h341.333334M682.666667 725.333333H341.333333c-93.866667 0-170.666667-76.8-170.666666-170.666666v-341.333334c0-93.866667 76.8-170.666667 170.666666-170.666666h341.333334c93.866667 0 170.666667 76.8 170.666666 170.666666V554.666667c0 93.866667-76.8 170.666667-170.666666 170.666666z",
              };
            }
          }),
        },
        grid: {
          right: 30,
          top: 75,
          bottom: showBol ? 100 : 49,
          left: 30,
          width: "auto",
          containLabel: true,
        },
        dataZoom: [
          {
            dataBackground: {
              //未选中部分数据阴影样式
              lineStyle: {
                opacity: 0,
              },
              areaStyle: {
                opacity: 0,
              },
            },
            selectedDataBackground: {
              //选中部分数据阴影样式
              lineStyle: {
                opacity: 0,
              },
              areaStyle: {
                opacity: 0,
              },
            },
            type: "slider",
            show: showBol ? true : false,
            right: 33,
            bottom: showBol ? 60 : 35,
            height: 6,
            borderColor: "#383848", //缩放条边框颜色
            fillerColor: "#383848", //选中的阴影填充背景颜色
            backgroundColor: "rgb(30,30,43)", // 背景颜色
            maxValueSpan: 6,
            handleSize: 0,
            brushSelect: false,
            showDetail: false,
            moveHandleStyle: {},
          },
        ],
        xAxis: {
          type: "category",
          axisPointer: {
            type: "shadow",
          },
          axisTick: {
            show: false,
          },
          axisLabel: {
            interval: 0,
            margin: 10,
            textStyle: {
              fontSize: 12,
              fontFamily: "SimSun",
              fontWeight: 400,
              color: "#838DA1",
            },
          },
          axisLine: {
            show: true,
            lineStyle: {
              color: "#46494A",
            },
          },
          data: this.sales.xAxis.data,
        },
        yAxis: [
          {
            type: "value",
            min: 0,
            axisLabel: {
              margin: 15,
              textStyle: {
                fontSize: 12,
                fontFamily: "SimSun",
                fontWeight: 400,
                color: "#838DA1",
              },
              formatter: "{value}",
            },
            splitLine: {
              show: true,
              lineStyle: {
                color: "#46494A",
                type: [10, 10],
                dashOffset: 5,
              },
            },
          },
          {
            type: "value",
            interval: 10,
            axisLabel: {
              margin: 10,
              textStyle: {
                fontSize: 12,
                fontFamily: "SimSun",
                fontWeight: 400,
                color: "#838DA1",
              },
              formatter: "",
            },
            splitLine: {
              show: false,
            },
          },
        ],
        series: this.sales.legend.data.map((item, idx) => {
          if (item.includes("应收款")) {
            return {
              name: this.sales.series[`data${idx + 1}`].name,
              type: "bar",
              tooltip: {
                valueFormatter: function (value) {
                  return value;
                },
              },
              itemStyle: {
                color: new $echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  { offset: 1, color: this.barColors[idx][1] },
                  { offset: 0, color: this.barColors[idx][0] },
                ]),
                barBorderRadius: 50,
              },
              emphasis: {
                itemStyle: {
                  color: new $echarts.graphic.LinearGradient(0, 0, 0, 1, [
                    { offset: 1, color: this.barColors[idx][1] },
                    { offset: 0, color: this.barColors[idx][0] },
                  ]),
                },
              },
              barMaxWidth: showBol ? "16" : "4",
              barGap: showBol ? 1 : 3,
              label: {
                normal: {
                  show: showBol ? true : false,
                  fontSize: 12,
                  color: "#ffffff",
                  position: "top",
                  formatter: (params) => {
                    if (params.value == 0) {
                      return ``;
                    }
                    return params.value; //随便写的值
                  },
                },
              },
              data: this.sales.series[`data${idx + 1}`].data,
            };
          } else {
            return {
              name: this.sales.series[`data${idx + 1}`].name,
              type: "line",
              yAxisIndex: 1,
              lineStyle: {
                color: this.lineColors[idx],
                width: 2,
              },
              emphasis: {
                focus: "series",
              },
              label: {
                show: showBol ? true : false,
                fontSize: 12,
                color: this.lineColors[idx],
                position: "top",
                distance: "30",
                formatter: (params) => {
                  return params.value + "%"; //随便写的值
                },
              },
              color: this.lineColors[idx],
              symbol: "none", //去掉折线图中的节点
              smooth: true, //true 为平滑曲线，false为直线
              connectNulls: true,
              showSymbol: this.sales.xAxis.data.length == 1 ? true : false,
              data: this.sales.series[`data${idx + 1}`].data,
            };
          }
        }),
      };
      if (option && typeof option === "object") {
        if (showBol) {
          this.isShowChart = true;
          setTimeout(() => {
            // 基于准备好的dom，初始化echarts实例
            this.showChart.chartDom = $echarts.init(
              document.getElementById(this.showChart.idName)
            );
            // this.annalsTarget.chartDom.setOption(option, this.animationDuration);
            this.showChart.chartDom.clear();
            if (this.showChart.searchType == "0") {
              this.closeFormatter(option);
              this.isDataZoomShow=false
              this.showChart.chartDom.setOption(option);
            } else if (this.showChart.searchType == "1") {
              this.closeFormatter(option2);
              this.isDataZoomShow=true
              this.showChart.chartDom.setOption(option2);
              this.showChart.option=option2
            } else if (this.showChart.searchType == "2") {
              this.closeFormatter(option3);
              this.isDataZoomShow=false
              this.showChart.chartDom.setOption(option3);
            }
          });
          return;
        }
        // 基于准备好的dom，初始化echarts实例
        this.sales.chartDom = $echarts.init(
          document.getElementById(this.sales.idName)
        );
        // this.sales.chartDom.setOption(option, this.animationDuration);
        this.sales.chartDom.clear();
        if (this.sales.searchType == "0") {
          this.sales.chartDom.setOption(option);
          this.sales.option = option;
        } else if (this.sales.searchType == "1") {
          this.sales.chartDom.setOption(option2);
          this.sales.option = option2;
        } else {
          this.sales.chartDom.setOption(option3);
          this.sales.option = option3;
        }
      }
    },
    // 单位利润计划与实际比option
    prefixChart(showBol) {
      // 指定图表的配置项和数据
      let option = {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross",
            crossStyle: {
              color: "#999",
            },
          },
          textStyle: {
            color: "#111E39",
            fontSize: 12,
            fontFamily: "Microsoft YaHei",
            fontWeight: 400,
          },
          formatter: (params) => {
            let dataStr = `<div><p style="font-weight:bold;margin:0 8px 10px;">${params[0].name}</p></div>`;
            params.forEach((item, i) => {
              dataStr += `<div style=${
                !item.data ? "display:none;" : "display:block"
              }>
          <div style="margin: 0 8px;">
            <span style="display:inline-block;margin-right:4px;width:8px;height:8px;border-radius:2px;background:linear-gradient(0deg, ${
              item.color.colorStops[0].color
            } 0%, ${item.color.colorStops[1].color} 100%);"></span>
            <span>${item.seriesName}</span>
            <span style="float:right;color:#000000;margin-left:20px;">${
              item.data
            } 元/斤</span>
          </div>
        </div>`;
            });
            return dataStr;
          },
        },
        legend: {
          type: "scroll",
          bottom: 10,
          left: 30,
          itemHeight: 8,
          itemGap: 40,
          itemWidth: 8,
          textStyle: {
            //图例文字的样式
            fontSize: "12px",
            fontFamily: "SimSun",
            fontWeight: 400,
            color: "#9BA7BF",
          },
          pageTextStyle: {
            color: "#9BA7BF",
            fontSize: 12,
            fontFamily: "SimSun",
          },
          pageIconColor: "#AAAAAA", //翻页下一页的三角按钮颜色
          pageIconInactiveColor: "#333333", //翻页按钮不激活时（即翻页到头时）的颜色。
          pageIconSize: 11, //翻页按钮大小
          data: this.prefix.legend.data.map((item) => {
            return {
              name: item,
              icon: "path://M682.666667 725.333333H341.333333c-93.866667 0-170.666667-76.8-170.666666-170.666666v-341.333334c0-93.866667 76.8-170.666667 170.666666-170.666666h341.333334c93.866667 0 170.666667 76.8 170.666666 170.666666V554.666667c0 93.866667-76.8 170.666667-170.666666 170.666666z",
            };
          }),
        },
        grid: {
          right: 30,
          top: 70,
          bottom: showBol ? 100 : 49,
          left: 30,
          width: "auto",
          containLabel: true,
        },
        dataZoom: [
          {
            dataBackground: {
              //未选中部分数据阴影样式
              lineStyle: {
                opacity: 0,
              },
              areaStyle: {
                opacity: 0,
              },
            },
            selectedDataBackground: {
              //选中部分数据阴影样式
              lineStyle: {
                opacity: 0,
              },
              areaStyle: {
                opacity: 0,
              },
            },
            type: "slider",
            show: showBol ? true : false,
            right: 33,
            bottom: showBol ? 60 : 35,
            height: 6,
            borderColor: "#383848", //缩放条边框颜色
            fillerColor: "#383848", //选中的阴影填充背景颜色
            backgroundColor: "rgb(30,30,43)", // 背景颜色
            maxValueSpan: 6,
            handleSize: 0,
            brushSelect: false,
            showDetail: false,
            moveHandleStyle: {},
          },
        ],
        xAxis: {
          type: "category",
          axisTick: {
            show: false,
          },
          axisPointer: {
            type: "shadow",
          },
          axisLabel: {
            interval: 0,
            margin: 10,
            textStyle: {
              fontSize: 12,
              fontFamily: "SimSun",
              fontWeight: 400,
              color: "#838DA1",
            },
          },
          axisLine: {
            show: true,
            lineStyle: {
              color: "#46494A",
            },
          },
          data: this.prefix.xAxis.data,
        },
        yAxis: [
          {
            type: "value",
            min: 0,
            // max: 200,
            // interval: 50,
            axisLabel: {
              margin: 15,
              textStyle: {
                fontSize: 12,
                fontFamily: "SimSun",
                fontWeight: 400,
                color: "#838DA1",
              },
              formatter: "{value}",
            },
            splitLine: {
              show: true,
              // interval: 0,
              lineStyle: {
                color: "#46494A",
                type: [10, 10],
                dashOffset: 5,
              },
            },
          },
        ],
        series: this.prefix.legend.data.map((item, idx) => {
          return {
            name: this.prefix.series[`data${idx + 1}`].name,
            type: "bar",
            tooltip: {
              valueFormatter: function (value) {
                return value;
              },
            },
            barMinWidth: showBol ? "10" : "4",
            barGap: showBol ? 1 : 3,
            label: {
              normal: {
                show: showBol ? true : false,
                fontSize: 12,
                color: "#ffffff",
                position: "center",
                rotate: "90",
                formatter: (params) => {
                  if (params.value == 0) {
                    return ``;
                  }
                  return params.value; //随便写的值
                },
              },
            },
            itemStyle: {
              color: new $echarts.graphic.LinearGradient(0, 0, 0, 1, [
                { offset: 1, color: this.barColors[idx][1] },
                { offset: 0, color: this.barColors[idx][0] },
              ]),
              barBorderRadius: 50,
            },
            emphasis: {
              itemStyle: {
                color: new $echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  { offset: 1, color: this.barColors[idx][1] },
                  { offset: 0, color: this.barColors[idx][0] },
                ]),
              },
            },
            data: this.prefix.series[`data${idx + 1}`].data,
          };
        }),
      };
      if (option && typeof option === "object") {
        if (showBol) {
          this.isShowChart = true;
          this.closeFormatter(option);
          setTimeout(() => {
            // 基于准备好的dom，初始化echarts实例
            this.showChart.chartDom = $echarts.init(
              document.getElementById(this.showChart.idName)
            );
            // this.annalsTarget.chartDom.setOption(option, this.animationDuration);
            this.showChart.chartDom.clear();
            this.showChart.chartDom.setOption(option);
          });
          return;
        }
        // 基于准备好的dom，初始化echarts实例
        this.prefix.chartDom = $echarts.init(
          document.getElementById(this.prefix.idName)
        );
        this.prefix.option = option;
        this.prefix.chartDom.clear();
        this.prefix.chartDom.setOption(option);
      }
    },
    // 成本概览option
    costChart(showBol) {
      // 指定图表的配置项和数据
      let option = {
        tooltip: {
          trigger: "axis",
          position: function (point, params, dom, rect, size) {
            const boxWidth = size.contentSize[0];
            return [point[0] - boxWidth - 25, point[1] + 25];
          },
          axisPointer: {
            type: "cross",
            crossStyle: {
              color: "#999",
            },
          },
          textStyle: {
            color: "#111E39",
            fontSize: 12,
            fontFamily: "Microsoft YaHei",
            fontWeight: 400,
          },
          formatter: (params) => {
            let dataStr = `<div><p style="font-weight:bold;margin:0 8px 10px;">${params[0].name}</p></div>`;
            params.forEach((item, i) => {
              dataStr += `<div style=${
                !item.data ? "display:none;" : "display:block"
              }>
          <div style="margin: 0 8px;">
            <span style="display:inline-block;margin-right:4px;width:8px;height:8px;border-radius:2px;background:linear-gradient(0deg, ${
              item.color.colorStops[0].color
            } 0%, ${item.color.colorStops[1].color} 100%);"></span>
            <span>${item.seriesName}</span>
            <span style="float:right;color:#000000;margin-left:20px;">${
              item.data
            } 万元</span>
          </div>
        </div>`;
            });
            return dataStr;
          },
        },
        legend: {
          type: "scroll",
          bottom: 10,
          left: 30,
          itemHeight: 8,
          itemGap: 40,
          itemWidth: 8,
          textStyle: {
            //图例文字的样式
            fontSize: "12px",
            fontFamily: "SimSun",
            fontWeight: 400,
            color: "#9BA7BF",
          },
          pageTextStyle: {
            color: "#9BA7BF",
            fontSize: 12,
            fontFamily: "SimSun",
          },
          pageIconColor: "#AAAAAA", //翻页下一页的三角按钮颜色
          pageIconInactiveColor: "#333333", //翻页按钮不激活时（即翻页到头时）的颜色。
          pageIconSize: 11, //翻页按钮大小
          data: this.cost.legend.data.map((item) => {
            return {
              name: item,
              icon: "path://M682.666667 725.333333H341.333333c-93.866667 0-170.666667-76.8-170.666666-170.666666v-341.333334c0-93.866667 76.8-170.666667 170.666666-170.666666h341.333334c93.866667 0 170.666667 76.8 170.666666 170.666666V554.666667c0 93.866667-76.8 170.666667-170.666666 170.666666z",
            };
          }),
        },
        grid: {
          right: 30,
          top: 35,
          bottom: showBol ? 100 : 49,
          left: 30,
          width: "auto",
          containLabel: true,
        },
        dataZoom: [
          {
            dataBackground: {
              //未选中部分数据阴影样式
              lineStyle: {
                opacity: 0,
              },
              areaStyle: {
                opacity: 0,
              },
            },
            selectedDataBackground: {
              //选中部分数据阴影样式
              lineStyle: {
                opacity: 0,
              },
              areaStyle: {
                opacity: 0,
              },
            },
            type: "slider",
            show: showBol ? true : false,
            right: 33,
            bottom: showBol ? 60 : 35,
            height: 6,
            borderColor: "#383848", //缩放条边框颜色
            fillerColor: "#383848", //选中的阴影填充背景颜色
            backgroundColor: "rgb(30,30,43)", // 背景颜色
            maxValueSpan: 6,
            handleSize: 0,
            brushSelect: false,
            showDetail: false,
            moveHandleStyle: {},
          },
        ],
        xAxis: [
          {
            type: "category",
            data: this.cost.xAxis.data,
            axisPointer: {
              type: "shadow",
            },
            axisLabel: {
              interval: 0,
              margin: 10,
              textStyle: {
                fontSize: 12,
                fontFamily: "SimSun",
                fontWeight: 400,
                color: "#838DA1",
              },
            },
            axisTick: {
              // x轴刻度线
              show: false,
            },
            axisLine: {
              show: true,
              lineStyle: {
                color: "#46494A",
              },
            },
          },
        ],
        yAxis: [
          {
            type: "value",
            min: 0,
            axisLabel: {
              margin: 15,
              textStyle: {
                fontSize: 12,
                fontFamily: "SimSun",
                fontWeight: 400,
                color: "#838DA1",
              },
              formatter: "{value}",
            },
            splitLine: {
              show: true,
              lineStyle: {
                color: "#46494A",
                type: [10, 10],
                dashOffset: 5,
              },
            },
          },
        ],
        series: this.cost.legend.data.map((item, idx) => {
          return {
            name: this.cost.series[`data${idx + 1}`].name,
            type: "bar",
            tooltip: {
              valueFormatter: function (value) {
                return value;
              },
            },
            barMaxWidth: showBol ? "10" : "4",
            barGap: showBol ? 1 : 3,
            label: {
              normal: {
                show: showBol ? true : false,
                position: "center",
                textStyle: {
                  color: "white",
                  fontStyle: "normal",
                  fontFamily: "微软雅黑",
                  fontSize: 12,
                },
                // offset: [0, 0],
                distance: "10",
                rotate: "90",
                formatter: (param) => {
                  if (param.value == 0) {
                    return ``;
                  }
                  return param.value;
                },
              },
            },
            itemStyle: {
              color: new $echarts.graphic.LinearGradient(0, 0, 0, 1, [
                { offset: 1, color: this.barColors[idx][1] },
                { offset: 0, color: this.barColors[idx][0] },
              ]),
              barBorderRadius: 50,
            },
            emphasis: {
              itemStyle: {
                color: new $echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  { offset: 1, color: this.barColors[idx][1] },
                  { offset: 0, color: this.barColors[idx][0] },
                ]),
              },
            },
            data: this.cost.series[`data${idx + 1}`].data,
          };
        }),
      };
      if (option && typeof option === "object") {
        if (showBol) {
          this.isShowChart = true;
          this.closeFormatter(option);
          setTimeout(() => {
            // 基于准备好的dom，初始化echarts实例
            this.showChart.chartDom = $echarts.init(
              document.getElementById(this.showChart.idName)
            );
            // this.annalsTarget.chartDom.setOption(option, this.animationDuration);
            this.showChart.chartDom.clear();
            this.showChart.chartDom.setOption(option);
          });
          return;
        }
        // 基于准备好的dom，初始化echarts实例
        this.cost.chartDom = $echarts.init(
          document.getElementById(this.cost.idName)
        );
        this.cost.option = option;
        this.cost.chartDom.clear();
        this.cost.chartDom.setOption(option);
      }
    },
    // 收获概览option
    harvestChart(showBol) {
      // 指定图表的配置项和数据
      let option = {
        baseOption: {
          // backgroundColor: "#1E1E2B",
          timeline: {
            show: false,
            top: 0,
            data: [],
          },
          grid: [
            {
              show: false,
              left: "4%",
              top: showBol ? "7%" : "25%",
              bottom: showBol ? 100 : 49,
              containLabel: true,
              width: "37%",
            },
            {
              show: false,
              left: "51%",
              top: showBol ? "7%" : "25%",
              bottom: showBol ? 100 : 49,
              width: "0%",
            },
            {
              show: false,
              right: "4%",
              top: showBol ? "7%" : "25%",
              bottom: showBol ? 100 : 49,
              containLabel: true,
              width: "37.6%",
            },
          ],
          dataZoom: [
            {
              yAxisIndex: 0,
              dataBackground: {
                //未选中部分数据阴影样式
                lineStyle: {
                  opacity: 0,
                },
                areaStyle: {
                  opacity: 0,
                },
              },
              selectedDataBackground: {
                //选中部分数据阴影样式
                lineStyle: {
                  opacity: 0,
                },
                areaStyle: {
                  opacity: 0,
                },
              },
              type: "slider",
              show: false,
              right: 42,
              bottom: 35,
              height: 6,
              borderColor: "#383848", //缩放条边框颜色
              fillerColor: "#383848", //选中的阴影填充背景颜色
              backgroundColor: "rgb(30,30,43)", // 背景颜色
              maxValueSpan: 3,
              handleSize: 0,
              brushSelect: false,
              showDetail: false,
              moveHandleStyle: {},
            },
            {
              yAxisIndex: 1,
              dataBackground: {
                //未选中部分数据阴影样式
                lineStyle: {
                  opacity: 0,
                },
                areaStyle: {
                  opacity: 0,
                },
              },
              selectedDataBackground: {
                //选中部分数据阴影样式
                lineStyle: {
                  opacity: 0,
                },
                areaStyle: {
                  opacity: 0,
                },
              },
              type: "slider",
              show: false,
              right: 42,
              bottom: 35,
              height: 6,
              borderColor: "#383848", //缩放条边框颜色
              fillerColor: "#383848", //选中的阴影填充背景颜色
              backgroundColor: "rgb(30,30,43)", // 背景颜色
              maxValueSpan: 3,
              handleSize: 0,
              brushSelect: false,
              showDetail: false,
              moveHandleStyle: {},
            },
            {
              yAxisIndex: 2,
              dataBackground: {
                //未选中部分数据阴影样式
                lineStyle: {
                  opacity: 0,
                },
                areaStyle: {
                  opacity: 0,
                },
              },
              selectedDataBackground: {
                //选中部分数据阴影样式
                lineStyle: {
                  opacity: 0,
                },
                areaStyle: {
                  opacity: 0,
                },
              },
              type: "slider",
              show: false,
              right: 42,
              bottom: 35,
              height: 6,
              borderColor: "#383848", //缩放条边框颜色
              fillerColor: "#383848", //选中的阴影填充背景颜色
              backgroundColor: "rgb(30,30,43)", // 背景颜色
              maxValueSpan: 3,
              handleSize: 0,
              brushSelect: false,
              showDetail: false,
              moveHandleStyle: {},
            },
          ],
          tooltip: {
            trigger: "axis",
            axisPointer: {
              type: "cross",
              crossStyle: {
                color: "#999",
              },
              label: {
                padding: [5, 13, 5, 13],
              },
            },
            textStyle: {
              color: "#111E39",
              fontSize: 12,
              fontFamily: "Microsoft YaHei",
              fontWeight: 400,
            },
            formatter: (params) => {
              let dataStr = `<div><p style="font-weight:bold;margin:0 8px 10px;">${params[0].name}</p></div>`;
              params.forEach((item, i) => {
                if (item.seriesName.indexOf("平均亩产") > -1) {
                  dataStr += `<div style=${
                    !item.data ? "display:none;" : "display:block"
                  }>
          <div style="margin: 0 8px;">
            <span style="display:inline-block;margin-right:4px;width:8px;height:8px;border-radius:2px;background:linear-gradient(0deg, ${
              item.color.colorStops[0].color
            } 0%, ${item.color.colorStops[1].color} 100%);"></span>
            <span>${item.seriesName}</span>
            <span style="float:right;color:#000000;margin-left:20px;">${
              item.data
            } 斤/亩</span>
          </div>
        </div>`;
                } else {
                  dataStr += `<div style=${
                    !item.data ? "display:none;" : "display:block"
                  }>
          <div style="margin: 0 8px;">
            <span style="display:inline-block;margin-right:4px;width:8px;height:8px;border-radius:2px;background:linear-gradient(0deg, ${
              item.color.colorStops[0].color
            } 0%, ${item.color.colorStops[1].color} 100%);"></span>
            <span>${item.seriesName}</span>
            <span style="float:right;color:#000000;margin-left:20px;">${
              item.data
            } 万斤</span>
          </div>
        </div>`;
                }
              });
              return dataStr;
            },
          },
          legend: {
            type: "scroll",
            bottom: 10,
            left: 30,
            itemHeight: 8,
            itemGap: 40,
            itemWidth: 8,
            pageTextStyle: {
              color: "#9BA7BF",
              fontSize: 12,
              fontFamily: "SimSun",
            },
            pageIconColor: "#AAAAAA", //翻页下一页的三角按钮颜色
            pageIconInactiveColor: "#333333", //翻页按钮不激活时（即翻页到头时）的颜色。
            pageIconSize: 11, //翻页按钮大小
            data: this.harvest.legend.data.map((re) => {
              return {
                name: re,
                textStyle: {
                  fontSize: 12,
                  fontFamily: "SimSun",
                  fontWeight: 400,
                  color: "#9BA7BF",
                },
                icon: "path://M682.666667 725.333333H341.333333c-93.866667 0-170.666667-76.8-170.666666-170.666666v-341.333334c0-93.866667 76.8-170.666667 170.666666-170.666666h341.333334c93.866667 0 170.666667 76.8 170.666666 170.666666V554.666667c0 93.866667-76.8 170.666667-170.666666 170.666666z",
              };
            }),
          },
          xAxis: [
            {
              type: "value",
              inverse: true,
              axisLine: {
                show: false,
              },
              axisTick: {
                show: false,
              },
              position: "bottom",
              axisLabel: {
                show: true,
                color: "#838DA1",
                hideOverlap: true,
              },
              splitLine: {
                show: true,
                lineStyle: {
                  color: "#46494A",
                },
              },
            },
            {
              gridIndex: 1,
              show: false,
            },
            {
              gridIndex: 2,
              axisLine: {
                show: false,
              },
              axisTick: {
                show: false,
              },
              position: "bottom",
              axisLabel: {
                show: true,
                color: "#838DA1",
                hideOverlap: true,
              },
              splitLine: {
                show: true,
                lineStyle: {
                  color: "#46494A",
                },
              },
            },
          ],
          yAxis: [
            {
              type: "category",
              inverse: true,
              position: "right",
              boundaryGap: true,
              axisPointer: {
                type: "shadow",
              },
              axisLine: {
                show: true,
                lineStyle: {
                  color: "#46494A",
                },
              },
              axisTick: {
                show: false,
              },
              axisLabel: {
                show: false,
              },
              data: this.harvest.xAxis.data,
            },
            {
              gridIndex: 1,
              type: "category",
              inverse: true,
              position: "left",
              axisLine: {
                show: false,
              },
              axisTick: {
                show: false,
              },
              axisLabel: {
                show: true,
                padding: [30, 30, 30, 30],
                textStyle: {
                  color: "#838DA1",
                  fontSize: 12,
                },
                align: "center",
              },
              data: this.harvest.xAxis.data.map(function (value) {
                return {
                  value: value,
                  textStyle: {
                    align: "center",
                  },
                };
              }),
            },
            {
              gridIndex: 2,
              type: "category",
              inverse: true,
              position: "left",
              boundaryGap: true,
              axisPointer: {
                type: "shadow",
              },
              axisLine: {
                show: true,
                lineStyle: {
                  color: "#46494A",
                },
              },
              axisTick: {
                show: false,
              },
              axisLabel: {
                show: false,
              },
              data: this.harvest.xAxis.data,
            },
          ],
          series: [],
        },
        options: [
          {
            series: this.harvest.legend.data.map((item, idx) => {
              if (item.includes("平均亩产")) {
                return {
                  name: this.harvest.series[`data${idx + 1}`].name,
                  type: "bar",
                  tooltip: {
                    valueFormatter: function (value) {
                      return value;
                    },
                  },
                  itemStyle: {
                    color: new $echarts.graphic.LinearGradient(0, 0, 0, 1, [
                      { offset: 1, color: this.barColors[idx][1] },
                      { offset: 0, color: this.barColors[idx][0] },
                    ]),
                    barBorderRadius: 50,
                  },
                  emphasis: {
                    itemStyle: {
                      color: new $echarts.graphic.LinearGradient(0, 0, 0, 1, [
                        { offset: 1, color: this.barColors[idx][1] },
                        { offset: 0, color: this.barColors[idx][0] },
                      ]),
                    },
                  },
                  barMaxWidth: showBol ? "7" : "4",
                  barGap: showBol ? 1 : 3,
                  label: {
                    normal: {
                      show: showBol ? true : false,
                      position: "left",
                      textStyle: {
                        color: "white",
                        fontStyle: "normal",
                        fontFamily: "微软雅黑",
                        fontSize: 10,
                      },
                      formatter: (param) => {
                        if (param.value == 0) {
                          return ``;
                        }
                        return param.value;
                      },
                    },
                  },
                  animationEasing: "elasticOut",
                  data: this.harvest.series[`data${idx + 1}`].data,
                };
              } else {
                return {
                  name: this.harvest.series[`data${idx + 1}`].name,
                  type: "bar",
                  xAxisIndex: 2,
                  yAxisIndex: 2,
                  tooltip: {
                    valueFormatter: function (value) {
                      return value;
                    },
                  },
                  itemStyle: {
                    color: new $echarts.graphic.LinearGradient(0, 0, 0, 1, [
                      { offset: 1, color: this.barColors[idx][1] },
                      { offset: 0, color: this.barColors[idx][0] },
                    ]),
                    barBorderRadius: 50,
                  },
                  emphasis: {
                    itemStyle: {
                      color: new $echarts.graphic.LinearGradient(0, 0, 0, 1, [
                        { offset: 1, color: this.barColors[idx][1] },
                        { offset: 0, color: this.barColors[idx][0] },
                      ]),
                    },
                  },
                  barMaxWidth: showBol ? "7" : "4",
                  barGap: showBol ? 1 : 3,
                  label: {
                    normal: {
                      show: showBol ? true : false,
                      position: "right",
                      textStyle: {
                        color: "white",
                        fontStyle: "normal",
                        fontFamily: "微软雅黑",
                        fontSize: 10,
                      },
                      formatter: (param) => {
                        if (param.value == 0) {
                          return ``;
                        }
                        return param.value;
                      },
                    },
                  },
                  animationEasing: "elasticOut",
                  data: this.harvest.series[`data${idx + 1}`].data,
                };
              }
            }),
          },
        ],
      };
      let option2 = {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross",
            crossStyle: {
              color: "#999",
            },
          },
          textStyle: {
            color: "#111E39",
            fontSize: 12,
            fontFamily: "Microsoft YaHei",
            fontWeight: 400,
          },
          formatter: (params) => {
            let dataStr = `<div><p style="font-weight:bold;margin:0 8px 10px;">${params[0].name}</p></div>`;
            params.forEach((item, i) => {
              if (!item.seriesName.includes("平均亩产")) {
                dataStr += `<div style=${
                  !item.data ? "display:none;" : "display:block"
                }>
               <div style="margin: 0 8px;">
                 <span style="display:inline-block;margin-right:4px;width:8px;height:8px;border-radius:2px;background:linear-gradient(0deg, ${
                   typeof item.color == "object"
                     ? item.color.colorStops[0].color
                     : ""
                 } 0%, ${
                  typeof item.color == "object"
                    ? item.color.colorStops[1].color
                    : ""
                } 100%);"></span>
                 <span>${item.seriesName}</span>
                 <span style="float:right;color:#000000;margin-left:20px;">${
                   item.data +
                   " " +
                   this.harvest.unit[this.harvest.searchType][0]
                 }</span>
               </div>
             </div>`;
              } else {
                dataStr += `<div style=${
                  !item.data ? "display:none;" : "display:block"
                }>
               <div style="margin: 0 6px;">
                 <span style="display:inline-block;position:relative;width:8px;margin-right:5px;
                 ">
                <svg class="icon" style="position:absolute;top:-9px" viewBox="0 0 1024 1024" xmlns="http://www.w3.org/2000/svg" width="12" height="12"><path d="M682.667 307.2c17.066 0 34.133 17.067 34.133 34.133v341.334c0 17.066-17.067 34.133-34.133 34.133H341.333c-17.066 0-34.133-17.067-34.133-34.133V341.333c0-17.066 17.067-34.133 34.133-34.133h341.334m0-136.533H341.333c-93.866 0-170.666 76.8-170.666 170.666v341.334c0 93.866 76.8 170.666 170.666 170.666h341.334c93.866 0 170.666-76.8 170.666-170.666V341.333c0-93.866-76.8-170.666-170.666-170.666z" fill="${
                  item.color
                }"/></svg>
                 </span>
                 <span>${item.seriesName}</span>
                 <span style="float:right;color:#000000;margin-left:20px;">${
                   item.data +
                   " " +
                   this.harvest.unit[this.harvest.searchType][1]
                 } </span>
               </div>
             </div>`;
              }
            });
            return dataStr;
          },
        },
        legend: {
          type: "scroll",
          bottom: 10,
          left: 30,
          itemHeight: 8,
          itemGap: 40,
          itemWidth: 8,
          textStyle: {
            //图例文字的样式
            fontSize: "12px",
            fontFamily: "SimSun",
            fontWeight: 400,
            color: "#9BA7BF",
          },
          pageTextStyle: {
            color: "#9BA7BF",
            fontSize: 12,
            fontFamily: "SimSun",
          },
          pageIconColor: "#AAAAAA", //翻页下一页的三角按钮颜色
          pageIconInactiveColor: "#333333", //翻页按钮不激活时（即翻页到头时）的颜色。
          pageIconSize: 11, //翻页按钮大小
          data: this.harvest.legend.data.map((item) => {
            if (!item.includes("平均亩产")) {
              return {
                name: item,
                icon: "path://M682.666667 725.333333H341.333333c-93.866667 0-170.666667-76.8-170.666666-170.666666v-341.333334c0-93.866667 76.8-170.666667 170.666666-170.666666h341.333334c93.866667 0 170.666667 76.8 170.666666 170.666666V554.666667c0 93.866667-76.8 170.666667-170.666666 170.666666z",
              };
            } else {
              return {
                name: item,
                icon: "path://M682.666667 588.8c17.066667 0 34.133333-17.066667 34.133333-34.133333v-341.333334c0-17.066667-17.066667-34.133333-34.133333-34.133333H341.333333c-17.066667 0-34.133333 17.066667-34.133333 34.133333V554.666667c0 17.066667 17.066667 34.133333 34.133333 34.133333h341.333334M682.666667 725.333333H341.333333c-93.866667 0-170.666667-76.8-170.666666-170.666666v-341.333334c0-93.866667 76.8-170.666667 170.666666-170.666666h341.333334c93.866667 0 170.666667 76.8 170.666666 170.666666V554.666667c0 93.866667-76.8 170.666667-170.666666 170.666666z",
              };
            }
          }),
        },
        grid: {
          right: 30,
          top: 75,
          bottom: showBol ? 100 : 49,
          left: 30,
          width: "auto",
          containLabel: true,
        },
        dataZoom: [
          {
            dataBackground: {
              //未选中部分数据阴影样式
              lineStyle: {
                opacity: 0,
              },
              areaStyle: {
                opacity: 0,
              },
            },
            selectedDataBackground: {
              //选中部分数据阴影样式
              lineStyle: {
                opacity: 0,
              },
              areaStyle: {
                opacity: 0,
              },
            },
            type: "slider",
            show: showBol ? true : false,
            right: 33,
            bottom: showBol ? 60 : 35,
            height: 6,
            borderColor: "#383848", //缩放条边框颜色
            fillerColor: "#383848", //选中的阴影填充背景颜色
            backgroundColor: "rgb(30,30,43)", // 背景颜色
            maxValueSpan: 6,
            handleSize: 0,
            brushSelect: false,
            showDetail: false,
            moveHandleStyle: {},
          },
        ],
        xAxis: [
          {
            type: "category",
            data: this.harvest.xAxis.data,
            axisPointer: {
              type: "shadow",
            },
            axisLabel: {
              interval: 0,
              margin: 10,
              textStyle: {
                fontSize: 12,
                fontFamily: "SimSun",
                fontWeight: 400,
                color: "#838DA1",
              },
            },
            axisTick: {
              // x轴刻度线
              show: false,
            },
            axisLine: {
              show: true,
              lineStyle: {
                color: "#46494A",
              },
            },
          },
        ],
        yAxis: [
          {
            type: "value",
            min: 0,
            axisLabel: {
              margin: 15,
              textStyle: {
                fontSize: 12,
                fontFamily: "SimSun",
                fontWeight: 400,
                color: "#838DA1",
              },
              formatter: "{value}",
            },
            splitLine: {
              show: true,
              lineStyle: {
                color: "#46494A",
                type: [10, 10],
                dashOffset: 5,
              },
            },
          },
          {
            type: "value",
            interval: 10,
            axisLabel: {
              margin: 10,
              textStyle: {
                fontSize: 12,
                fontFamily: "SimSun",
                fontWeight: 400,
                color: "#838DA1",
              },
              formatter: "",
            },
            splitLine: {
              show: false,
            },
          },
        ],
        series: this.harvest.legend.data.map((item, idx) => {
          if (!item.includes("平均亩产")) {
            return {
              name: this.harvest.series[`data${idx + 1}`].name,
              type: "bar",
              tooltip: {
                valueFormatter: function (value) {
                  return value;
                },
              },
              itemStyle: {
                color: new $echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  { offset: 1, color: this.barColors[idx][1] },
                  { offset: 0, color: this.barColors[idx][0] },
                ]),
                barBorderRadius: 50,
              },
              emphasis: {
                itemStyle: {
                  color: new $echarts.graphic.LinearGradient(0, 0, 0, 1, [
                    { offset: 1, color: this.barColors[idx][1] },
                    { offset: 0, color: this.barColors[idx][0] },
                  ]),
                },
              },
              barMaxWidth: showBol ? "10" : "4",
              barGap: showBol ? 1 : 3,
              label: {
                normal: {
                  show: showBol ? true : false,
                  position: "top",
                  textStyle: {
                    color: "white",
                    fontStyle: "normal",
                    fontFamily: "微软雅黑",
                    fontSize: 10,
                  },
                  formatter: (param) => {
                    if (param.value == 0) {
                      return ``;
                    }
                    return param.value;
                  },
                },
              },
              data: this.harvest.series[`data${idx + 1}`].data,
            };
          } else {
            return {
              name: this.harvest.series[`data${idx + 1}`].name,
              type: "line",
              yAxisIndex: 1,
              lineStyle: {
                color: this.lineColors[idx],
                width: 2,
              },
              emphasis: {
                focus: "series",
              },
              color: this.lineColors[idx],
              symbol: "none", //去掉折线图中的节点
              smooth: true, //true 为平滑曲线，false为直线
              connectNulls: true,
              showSymbol: this.harvest.xAxis.data.length == 1 ? true : false,
              data: this.harvest.series[`data${idx + 1}`].data,
            };
          }
        }),
      };
      if (option && typeof option === "object") {
        if (showBol) {
          this.isShowChart = true;
          setTimeout(() => {
            // 基于准备好的dom，初始化echarts实例
            this.showChart.chartDom = $echarts.init(
              document.getElementById(this.showChart.idName)
            );
            // this.annalsTarget.chartDom.setOption(option, this.animationDuration);
            this.showChart.chartDom.clear();
            if (this.showChart.searchType == "0") {
              this.closeFormatter(option);
              this.isDataZoomShow=true
              this.showChart.chartDom.setOption(option);
              this.showChart.option=option
            } else if (this.showChart.searchType == "1") {
              this.closeFormatter(option2);
              this.isDataZoomShow=false
              this.showChart.chartDom.setOption(option2);
            } else if (this.showChart.searchType == "2") {
              this.isDataZoomShow=false
              this.closeFormatter(option3);
              this.showChart.chartDom.setOption(option3);
            }
          });
          return;
        }
        // 基于准备好的dom，初始化echarts实例
        this.harvest.chartDom = $echarts.init(
          document.getElementById(this.harvest.idName)
        );
        this.harvest.chartDom.clear();
        if (this.harvest.searchType == "0") {
          this.harvest.chartDom.setOption(option);
          this.harvest.option = option;
        } else if (this.harvest.searchType == "1") {
          this.harvest.chartDom.setOption(option2);
          this.harvest.option = option2;
        }
      }
    },
    // 指标概览option
    quotaChart(showBol) {
      // 指定图表的配置项和数据
      let option = {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross",
            crossStyle: {
              color: "#999",
            },
          },
          textStyle: {
            color: "#111E39",
            fontSize: 12,
            fontFamily: "Microsoft YaHei",
            fontWeight: 400,
          },
          formatter: (params) => {
            let dataStr = `<div><p style="font-weight:bold;margin:0 8px 10px;">${params[0].name}</p></div>`;
            params.forEach((item, i) => {
              dataStr += `<div style=${
                !item.data ? "display:none;" : "display:block"
              }>
          <div style="margin: 0 8px;">
            <span style="display:inline-block;margin-right:4px;width:8px;height:8px;border-radius:2px;background:linear-gradient(0deg, ${
              item.color.colorStops[0].color
            } 0%, ${item.color.colorStops[1].color} 100%);"></span>
            <span>${item.seriesName}</span>
            <span style="float:right;color:#000000;margin-left:20px;">${
              item.data
            } ${this.quota.searchType == "0" ? "%" : ""}</span>
          </div>
        </div>`;
            });
            return dataStr;
          },
        },
        legend: {
          type: "scroll",
          bottom: 10,
          left: 30,
          itemHeight: 8,
          itemGap: 40,
          itemWidth: 8,
          textStyle: {
            //图例文字的样式
            fontSize: "12px",
            fontFamily: "SimSun",
            fontWeight: 400,
            color: "#9BA7BF",
          },
          pageTextStyle: {
            color: "#9BA7BF",
            fontSize: 12,
            fontFamily: "SimSun",
          },
          pageIconColor: "#AAAAAA", //翻页下一页的三角按钮颜色
          pageIconInactiveColor: "#333333", //翻页按钮不激活时（即翻页到头时）的颜色。
          pageIconSize: 11, //翻页按钮大小
          data: this.quota.legend.data.map((item) => {
            return {
              name: item,
              icon: "path://M682.666667 725.333333H341.333333c-93.866667 0-170.666667-76.8-170.666666-170.666666v-341.333334c0-93.866667 76.8-170.666667 170.666666-170.666666h341.333334c93.866667 0 170.666667 76.8 170.666666 170.666666V554.666667c0 93.866667-76.8 170.666667-170.666666 170.666666z",
            };
          }),
        },
        grid: {
          right: 30,
          top: 70,
          bottom: showBol ? 100 : 49,
          left: 30,
          width: "auto",
          containLabel: true,
        },
        dataZoom: [
          {
            dataBackground: {
              //未选中部分数据阴影样式
              lineStyle: {
                opacity: 0,
              },
              areaStyle: {
                opacity: 0,
              },
            },
            selectedDataBackground: {
              //选中部分数据阴影样式
              lineStyle: {
                opacity: 0,
              },
              areaStyle: {
                opacity: 0,
              },
            },
            type: "slider",
            show: showBol ? true : false,
            right: 33,
            bottom: showBol ? 60 : 35,
            height: 6,
            borderColor: "#383848", //缩放条边框颜色
            fillerColor: "#383848", //选中的阴影填充背景颜色
            backgroundColor: "rgb(30,30,43)", // 背景颜色
            maxValueSpan: 6,
            handleSize: 0,
            brushSelect: false,
            showDetail: false,
            moveHandleStyle: {},
          },
        ],
        xAxis: [
          {
            type: "category",
            data: this.quota.xAxis.data,
            axisPointer: {
              type: "shadow",
            },
            axisLabel: {
              interval: 0,
              margin: 10,
              textStyle: {
                fontSize: 12,
                fontFamily: "SimSun",
                fontWeight: 400,
                color: "#838DA1",
              },
            },
            axisTick: {
              // x轴刻度线
              show: false,
            },
            axisLine: {
              show: true,
              lineStyle: {
                color: "#46494A",
              },
            },
          },
        ],
        yAxis: [
          {
            type: "value",
            min: 0,
            axisLabel: {
              margin: 15,
              textStyle: {
                fontSize: 12,
                fontFamily: "SimSun",
                fontWeight: 400,
                color: "#838DA1",
              },
              formatter: "{value}",
            },
            splitLine: {
              show: true,
              lineStyle: {
                color: "#46494A",
                type: [10, 10],
                dashOffset: 5,
              },
            },
          },
        ],
        series: this.quota.legend.data.map((item, idx) => {
          return {
            name: this.quota.series[`data${idx + 1}`].name,
            type: "bar",
            stack: this.quota.series[`data${idx + 1}`].stack,
            tooltip: {
              valueFormatter: function (value) {
                return value;
              },
            },
            barMaxWidth: showBol ? "10" : "4",
            barGap: showBol ? 1 : 3,
            label: {
              normal: {
                show: showBol ? true : false,
                position: "inside",
                textStyle: {
                  color: "white",
                  fontStyle: "normal",
                  fontFamily: "微软雅黑",
                  fontSize: 12,
                },
                // offset: [0, 0],
                formatter: (param) => {
                  if (param.value == 0) {
                    return ``;
                  }
                  return param.value;
                },
              },
            },
            itemStyle: {
              color: new $echarts.graphic.LinearGradient(0, 0, 0, 1, [
                { offset: 1, color: this.barColors[idx][1] },
                { offset: 0, color: this.barColors[idx][0] },
              ]),
              barBorderRadius: showBol ? 0 : 50,
            },
            emphasis: {
              itemStyle: {
                color: new $echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  { offset: 1, color: this.barColors[idx][1] },
                  { offset: 0, color: this.barColors[idx][0] },
                ]),
              },
            },
            data: this.quota.series[`data${idx + 1}`].data,
          };
        }),
      };
      if (option && typeof option === "object") {
        if (showBol) {
          this.isShowChart = true;
          this.closeFormatter(option);
          setTimeout(() => {
            // 基于准备好的dom，初始化echarts实例
            this.showChart.chartDom = $echarts.init(
              document.getElementById(this.showChart.idName)
            );
            // this.annalsTarget.chartDom.setOption(option, this.animationDuration);
            this.showChart.chartDom.clear();
            this.showChart.chartDom.setOption(option);
          });
          return;
        }
        // 基于准备好的dom，初始化echarts实例
        this.quota.chartDom = $echarts.init(
          document.getElementById(this.quota.idName)
        );
        this.quota.option = option;
        this.quota.chartDom.clear();
        this.quota.chartDom.setOption(option);
      }
    },
    // 获取年度经营目标完成情况数据
    annalsTargetInfo(searchType /**指标类型 0 ~ n */, showBol) {
      this.annalsTarget.searchType = searchType;
      service
        .annalsTargetInfo({
          orgId: this.orgId,
          type: this.type,
          year: this.year,
          month: this.month,
          breedTypeClass: this.breedTypeClass,
          searchType: searchType,
        })
        .then((data) => {
          if (data.code == "0000") {
            const DATA = data.data || [];
            this.resetChartData(this.annalsTarget); // 重置图表数据
            // 赋值， 过滤数据
            this.handleChartData(DATA, this.annalsTarget);
          }
          if (showBol) {
            const DATA = data.data || [];
            this.resetChartData(this.showChart);
            this.handleChartData(DATA, this.showChart);
            this.annalsTargetChart(showBol); // 获取数据后再设置一遍option
            return;
          }
          this.annalsTargetChart(); // 获取数据后再设置一遍option
        });
    },
    // 获取投放概览数据
    putInfo(searchType /**指标类型 0 ~ n */, showBol) {
      if (!showBol) {
        this.put.searchType = searchType;
      }
      this.resetChartData(this.put); // 重置图表数据
      service
        .putInfo({
          orgId: this.orgId,
          type: this.type,
          year: this.year,
          month: this.month,
          breedTypeClass: this.breedTypeClass,
          searchType: searchType,
        })
        .then((data) => {
          if (data.code == "0000") {
            const DATA = data.data || [];
            // 赋值， 过滤数据
            this.handleChartData(DATA, this.put);
          }
          if (showBol) {
            const DATA = data.data || [];
            this.resetChartData(this.showChart);
            this.handleChartData(DATA, this.showChart);
            this.putChart(showBol); // 获取数据后再设置一遍option
            return;
          }
          this.putChart(); // 获取数据后再设置一遍option
        });
    },
    // 获取存塘概览数据
    storageInfo(searchType /**指标类型 0 ~ n */, showBol) {
      if (!showBol) {
        this.storage.searchType = searchType;
      }
      this.resetChartData(this.storage); // 重置图表数据
      service
        .storageInfo({
          orgId: this.orgId,
          type: this.type,
          year: this.year,
          month: this.month,
          breedTypeClass: this.breedTypeClass,
          searchType: searchType,
        })
        .then((data) => {
          if (data.code == "0000") {
            const DATA = data.data || [];
            // 赋值， 过滤数据
            this.handleChartData(DATA, this.storage);
          }
          if (showBol) {
            const DATA = data.data || [];
            this.resetChartData(this.showChart);
            this.handleChartData(DATA, this.showChart);
            this.storageChart(showBol); // 获取数据后再设置一遍option
            return;
          }
          this.storageChart(); // 获取数据后再设置一遍option
        });
    },
    // 获取销售概览数据
    salesInfo(searchType /**指标类型 0 ~ n */, showBol) {
      if (!showBol) {
        this.sales.searchType = searchType;
      }
      this.resetChartData(this.sales); // 重置图表数据
      service
        .salesInfo({
          orgId: this.orgId,
          type: this.type,
          year: this.year,
          month: this.month,
          breedTypeClass: this.breedTypeClass,
          searchType: searchType,
        })
        .then((data) => {
          if (data.code == "0000") {
            const DATA = data.data || [];
            // 赋值， 过滤数据
            this.handleChartData(DATA, this.sales);
          }
          if (showBol) {
            const DATA = data.data || [];
            this.resetChartData(this.showChart);
            this.handleChartData(DATA, this.showChart);
            this.salesChart(showBol); // 获取数据后再设置一遍option
            return;
          }
          this.salesChart(); // 获取数据后再设置一遍option
        });
    },
    // 获取单位利润计划与实际比数据
    prefixInfo(searchType /**指标类型 0 ~ n */, showBol) {
      if (!showBol) {
        this.prefix.searchType = searchType;
      }
      this.resetChartData(this.prefix); // 重置图表数据
      service
        .prefixInfo({
          orgId: this.orgId,
          type: this.type,
          year: this.year,
          month: this.month,
          breedTypeClass: this.breedTypeClass,
          searchType: searchType,
        })
        .then((data) => {
          if (data.code == "0000") {
            const DATA = data.data || [];
            // 赋值， 过滤数据
            this.handleChartData(DATA, this.prefix);
          }
          if (showBol) {
            const DATA = data.data || [];
            this.resetChartData(this.showChart);
            this.handleChartData(DATA, this.showChart);
            this.prefixChart(showBol); // 获取数据后再设置一遍option
            return;
          }
          this.prefixChart(); // 获取数据后再设置一遍option
        });
    },
    //  获取成本概览数据
    costInfo(showBol) {
      this.resetChartData(this.prefix); // 重置图表数据
      service
        .costInfo({
          orgId: this.orgId,
          type: this.type,
          year: this.year,
          month: this.month,
          breedTypeClass: this.breedTypeClass,
        })
        .then((data) => {
          if (data.code == "0000") {
            const DATA = data.data || [];
            // 赋值， 过滤数据
            this.handleChartData(DATA, this.cost);
          }
          if (showBol) {
            const DATA = data.data || [];
            this.resetChartData(this.showChart);
            this.handleChartData(DATA, this.showChart);
            this.costChart(showBol); // 获取数据后再设置一遍option
            return;
          }
          this.costChart(); // 获取数据后再设置一遍option
        });
    },
    //  获取收获概览数据
    harvestInfo(searchType /**指标类型 0 ~ n */, showBol) {
      this.harvest.searchType = searchType;
      this.resetChartData(this.harvest); // 重置图表数据
      service
        .harvestInfo({
          orgId: this.orgId,
          type: this.type,
          year: this.year,
          month: this.month,
          breedTypeClass: this.breedTypeClass,
          searchType: searchType,
        })
        .then((data) => {
          if (data.code == "0000") {
            const DATA = data.data || [];
            // 赋值， 过滤数据
            this.handleChartData(DATA, this.harvest);
          }
          if (showBol) {
            const DATA = data.data || [];
            this.resetChartData(this.showChart);
            this.handleChartData(DATA, this.showChart);
            this.harvestChart(showBol); // 获取数据后再设置一遍option
            return;
          }
          this.harvestChart(); // 获取数据后再设置一遍option
        });
    },
    //  获取指标概览数据
    quotaInfo(searchType /**指标类型 0 ~ n */, showBol) {
      if (!showBol) {
        this.quota.searchType = searchType;
      }
      this.resetChartData(this.quota); // 重置图表数据
      service
        .quotaInfo({
          orgId: this.orgId,
          type: this.type,
          year: this.year,
          month: this.month,
          breedTypeClass: this.breedTypeClass,
          searchType: searchType,
        })
        .then((data) => {
          if (data.code == "0000") {
            const DATA = data.data || [];
            // 赋值， 过滤数据
            this.handleChartData(DATA, this.quota);
            // 设置堆叠
            this.quota.legend.data.forEach((item, idx) => {
              const stack = item.slice(0, 6);
              this.quota.series[`data${idx + 1}`].stack = stack;
            });
          }
          if (showBol) {
            const DATA = data.data || [];
            this.resetChartData(this.showChart);
            this.handleChartData(DATA, this.showChart);
            this.quotaChart(showBol); // 获取数据后再设置一遍option
            return;
          }
          this.q;
          this.quotaChart(); // 获取数据后再设置一遍option
        });
    },
    //  获取汇总数据
    totalDataInfo() {
      service
        .totalDataInfo({
          orgId: this.orgId,
          type: this.type,
          year: this.year,
          month: this.month,
          breedTypeClass: this.breedTypeClass,
        })
        .then((data) => {
          if (data.code == "0000") {
            this.totalData = data.data;
          }
        });
    },
  },
  created() {
    this.randomColors(100);
    this.orgId = localStorage.getItem("orgId");
    this.type =
      this.app.dateType == "year" || this.app.dateType == "day" ? "Y" : "M";
    if (this.app.dateType == "year") {
      this.year = this.app.date;
    } else if (this.app.dateType == "month") {
      this.month = this.app.date;
    } else if (this.app.dateType == "day") {
      this.year = this.app.date.slice(0, 4);
    }
    this.totalDataInfo();
    // 获取图标数据
    this.annalsTargetInfo(this.annalsTarget.searchType);
    this.putInfo(this.put.searchType);
    this.storageInfo(this.storage.searchType);
    this.salesInfo(this.sales.searchType);
    this.prefixInfo(this.prefix.searchType);
    this.costInfo(this.cost.searchType);
    this.harvestInfo(this.harvest.searchType);
    this.quotaInfo(this.quota.searchType);

    // echart自适应
    // debounce函数让一个方法在一定时间内只能执行一次
    this.resizeHandler = debounce(
      () => {
        this.annalsTarget.chartDom && this.annalsTarget.chartDom.resize();
        this.put.chartDom && this.put.chartDom.resize();
        this.storage.chartDom && this.storage.chartDom.resize();
        this.sales.chartDom && this.sales.chartDom.resize();
        this.prefix.chartDom && this.prefix.chartDom.resize();
        this.cost.chartDom && this.cost.chartDom.resize();
        this.harvest.chartDom && this.harvest.chartDom.resize();
        this.quota.chartDom && this.quota.chartDom.resize();
      },
      100,
      false
    );
    // 监听浏览器窗口页面
    window.addEventListener("resize", this.resizeHandler);
  },
  // 数据监听
  watch: {
    dateType: function (value) {
      this.type = value == "year" ? "Y" : "M";
      this.type == "Y" ? (this.month = "") : (this.year = "");
    },
    date: function (value, old) {
      if (/^\d{4}$/.test(value)) {
        this.year = value;
      } else if (/^\d{4}-((0([1-9]))|(1(0|1|2)))$/.test(value)) {
        this.month = value;
      }
      this.randomColors(100);
      // 获取图标数据
      this.annalsTargetInfo(this.annalsTarget.searchType);
      this.putInfo(this.put.searchType);
      this.storageInfo(this.storage.searchType);
      this.salesInfo(this.sales.searchType);
      this.prefixInfo(this.prefix.searchType);
      this.costInfo(this.cost.searchType);
      this.harvestInfo(this.harvest.searchType);
      this.quotaInfo(this.quota.searchType);
      this.totalDataInfo();
    },
  },
};
</script>

<style lang="less" scoped>
.content-box {
  width: 100%;
  min-height: 940px;
  height: auto;
  overflow-y: hidden;
  display: flex;
  background: #181a1f;
  // 布局样式
  > div {
    // 去除左右两边外间距和盒子的外间距
    width: calc((100% - 7px - 7px - 7px - 7px) / 3);

    &:first-child {
      margin-left: 7px;
    }
    &:not(:first-child) {
      margin-left: 7px;
    }

    // 盒子样式
    .sub-box {
      width: 100%;
      height: 304.33px;
      background: #1e1e2b;
      box-sizing: border-box;
      border: 1px solid #34324d;

      &:first-child {
        margin-top: 7px;
      }
      &:not(:first-child) {
        margin-top: 7px;
      }
      &:last-child {
        margin-bottom: 7px;
      }

      // 盒子标题
      .big-title {
        height: auto;
        font-size: 20px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #ffffff;
        display: inline-block;
        position: relative;
        width: 100%;

        > span {
          position: relative;
          margin-left: 30px;
          margin-top: 7px;
          display: inline-block;

          &::after {
            position: absolute;
            content: "";
            width: 4px;
            height: 17px;
            background: #8631f0;
            border-radius: 4px 0px 4px 0px;
            top: 6px;
            left: -10px;
          }
        }
        // 查看更多
        .title-right {
          display: inline-block;
          position: absolute;
          top: 7px;
          right: 22px;

          span {
            font-size: 12px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #d7d7d9;

            > i {
              font-size: 13px;
              font-family: Microsoft YaHei;
              font-weight: 400;
              color: #d7d7d9;
            }
          }
        }
      }

      // 图表盒子
      .chart-content {
        width: 100%;
        height: calc(100% - 33px);
        position: relative;

        // 图表选项
        .sub-titles {
          position: absolute;
          top: 14px;
          left: 30px;
          z-index: 1;
          > span {
            font-size: 14px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #ffffff;
            margin-right: 40px;
            cursor: pointer;
          }
          .sub-active {
            display: inline-block;
            padding: 6px 14px;
            background: linear-gradient(90deg, #ab19f7 0%, #15a8c2 100%);
            border-radius: 14px;
          }
        }
      }
    }
    .sub-box-middle {
      height: 403px;
    }

    // 顶部数字盒子
    .num-box {
      display: flex;
      justify-content: space-between;
      margin-top: 7px;
      > span {
        display: inline-block;
        width: 152px;
        height: 107px;
        background: #5442ff;
      }
      .count-txt {
        display: inline-block;
        height: 15px;
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #ffffff;
        width: 100%;
        text-align: center;
      }
    }
  }
}

// 1920分辨率，盒子高度作改变

// 1366分辨率，盒子高度作改变
</style>